// 145 Prep Kitchen products - affiliate catalog
// Source: theprepkitchen.com

export const AFFILIATE_CODE = 'NINJA';
export const AFFILIATE_DISCOUNT = 20;
export const MERCHANT_NAME = 'The Prep Kitchen';
export const MERCHANT_URL = 'https://theprepkitchen.com';

export const PRODUCTS = [
  {
    "name": "Waffle, Eggs and Bacon",
    "slug": "waffle-eggs-and-bacon",
    "category": "Breakfast",
    "badge": "NEW",
    "price": 9.99,
    "calories": 480,
    "fat": 21,
    "carbs": 54,
    "protein": 19,
    "sourceUrl": "https://theprepkitchen.com/product/waffle-eggs-and-bacon?pid=9a12213c-43a3-4c24-bc50-08deacb48454",
    "imageUrl": "/api/products/images/fitpromeals/products/waffle-eggs-and-bacon.webp",
    "imageAlt": "Waffle, Eggs and Bacon prepared by The Prep Kitchen",
    "affiliateTitle": "Waffle, Eggs and Bacon Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Waffle, Eggs and Bacon from The Prep Kitchen with 19g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Waffle, Eggs and Bacon is a prepared breakfast option from The Prep Kitchen with 480 calories, 19g protein, 54g carbs, 21g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Waffle, Eggs and Bacon is a prepared breakfast option from The Prep Kitchen with 480 calories, 19g protein, 54g carbs, 21g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "9a12213c-43a3-4c24-bc50-08deacb48454",
    "pradoVariantId": "19036e5a-45f1-455c-f363-08deacb4850d"
  },
  {
    "name": "Turkey Sausage Egg White Bowl",
    "slug": "turkey-sausage-egg-white-bowl",
    "category": "Breakfast",
    "badge": null,
    "price": 10.99,
    "calories": 460,
    "fat": 13,
    "carbs": 51,
    "protein": 35,
    "sourceUrl": "https://theprepkitchen.com/product/turkey-sausage-egg-white-bowl?pid=ba7683ef-247b-41c8-009b-08ddf08bd2e1",
    "imageUrl": "/api/products/images/fitpromeals/products/turkey-sausage-egg-white-bowl.webp",
    "imageAlt": "Turkey Sausage Egg White Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Turkey Sausage Egg White Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Turkey Sausage Egg White Bowl from The Prep Kitchen with 35g protein. See nutrition details and check current DFW availability through our affiliat…",
    "description": "Turkey Sausage Egg White Bowl is a prepared breakfast option from The Prep Kitchen with 460 calories, 35g protein, 51g carbs, 13g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Turkey Sausage Egg White Bowl is a prepared breakfast option from The Prep Kitchen with 460 calories, 35g protein, 51g carbs, 13g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "ba7683ef-247b-41c8-009b-08ddf08bd2e1",
    "pradoVariantId": "ca8d57c1-3d09-491d-898a-08ddf08bd301"
  },
  {
    "name": "Shredded Chicken Breakfast Bowl",
    "slug": "shredded-chicken-breakfast-bowl",
    "category": "Breakfast",
    "badge": null,
    "price": 10.99,
    "calories": 630,
    "fat": 31,
    "carbs": 36,
    "protein": 50,
    "sourceUrl": "https://theprepkitchen.com/product/shredded-chicken-breakfast-bowl?pid=5f710cb6-9714-44d3-7414-08de31fc5a9d",
    "imageUrl": "/api/products/images/fitpromeals/products/shredded-chicken-breakfast-bowl.webp",
    "imageAlt": "Shredded Chicken Breakfast Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Shredded Chicken Breakfast Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Shredded Chicken Breakfast Bowl from The Prep Kitchen with 50g protein. See nutrition details and check current DFW availability through our affili…",
    "description": "Shredded Chicken Breakfast Bowl is a prepared breakfast option from The Prep Kitchen with 630 calories, 50g protein, 36g carbs, 31g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Shredded Chicken Breakfast Bowl is a prepared breakfast option from The Prep Kitchen with 630 calories, 50g protein, 36g carbs, 31g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "5f710cb6-9714-44d3-7414-08de31fc5a9d",
    "pradoVariantId": "62f6ef19-c044-41f4-ee5e-08de31fc5b5f"
  },
  {
    "name": "Breakfast Bundle",
    "slug": "breakfast-bundle",
    "category": "Breakfast",
    "badge": null,
    "price": 68.43,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/breakfast-bundle?pid=1b1e6751-efa8-4bbd-7309-08dd98a512c1",
    "imageUrl": "/api/products/images/fitpromeals/products/breakfast-bundle.webp",
    "imageAlt": "Breakfast Bundle prepared by The Prep Kitchen",
    "affiliateTitle": "Breakfast Bundle Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Breakfast Bundle from The Prep Kitchen. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Breakfast Bundle is a prepared breakfast option from The Prep Kitchen. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Breakfast Bundle is a prepared breakfast option from The Prep Kitchen. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "1b1e6751-efa8-4bbd-7309-08dd98a512c1",
    "pradoVariantId": "73e5d7e7-097f-4997-ecb2-08dd98a512d2"
  },
  {
    "name": "Bacon and Egg Breakfast Burrito",
    "slug": "bacon-and-egg-breakfast-burrito",
    "category": "Breakfast",
    "badge": null,
    "price": 9.99,
    "calories": 380,
    "fat": 20,
    "carbs": 42,
    "protein": 26,
    "sourceUrl": "https://theprepkitchen.com/product/bacon-egg-burrito?pid=02441f77-a1a3-4f86-ffb6-08dd81f7d172",
    "imageUrl": "/api/products/images/fitpromeals/products/bacon-and-egg-breakfast-burrito.webp",
    "imageAlt": "Bacon and Egg Breakfast Burrito prepared by The Prep Kitchen",
    "affiliateTitle": "Bacon and Egg Breakfast Burrito Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Bacon and Egg Breakfast Burrito from The Prep Kitchen with 26g protein. See nutrition details and check current DFW availability through our affili…",
    "description": "Bacon and Egg Breakfast Burrito is a prepared breakfast option from The Prep Kitchen with 380 calories, 26g protein, 42g carbs, 20g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Bacon and Egg Breakfast Burrito is a prepared breakfast option from The Prep Kitchen with 380 calories, 26g protein, 42g carbs, 20g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "02441f77-a1a3-4f86-ffb6-08dd81f7d172",
    "pradoVariantId": "9e5e4843-62f7-4b1f-f904-08dd81f7d17b"
  },
  {
    "name": "Steak, Eggs, Potatoes",
    "slug": "steak-eggs-potatoes",
    "category": "Breakfast",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 700,
    "fat": 35,
    "carbs": 28,
    "protein": 65,
    "sourceUrl": "https://theprepkitchen.com/product/steal-eggs-potatoes?pid=05488303-d4d0-4bc2-40a6-08dd81f6a2bd",
    "imageUrl": "/api/products/images/fitpromeals/products/steak-eggs-potatoes.webp",
    "imageAlt": "Steak, Eggs, Potatoes prepared by The Prep Kitchen",
    "affiliateTitle": "Steak, Eggs, Potatoes Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Steak, Eggs, Potatoes from The Prep Kitchen with 65g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Steak, Eggs, Potatoes is a prepared breakfast option from The Prep Kitchen with 700 calories, 65g protein, 28g carbs, 35g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Steak, Eggs, Potatoes is a prepared breakfast option from The Prep Kitchen with 700 calories, 65g protein, 28g carbs, 35g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "05488303-d4d0-4bc2-40a6-08dd81f6a2bd",
    "pradoVariantId": "da257948-4080-44b4-a54e-08dd81f6a2c4"
  },
  {
    "name": "Chicken Sausage Breakfast Tacos",
    "slug": "chicken-sausage-breakfast-tacos",
    "category": "Breakfast",
    "badge": null,
    "price": 9.99,
    "calories": 230,
    "fat": 13,
    "carbs": 17,
    "protein": 13,
    "sourceUrl": "https://theprepkitchen.com/product/chicken-sausage-breakfast-tacos?pid=156bb8c5-7b11-44a9-c59c-08dd81f6a044",
    "imageUrl": "/api/products/images/fitpromeals/products/chicken-sausage-breakfast-tacos.webp",
    "imageAlt": "Chicken Sausage Breakfast Tacos prepared by The Prep Kitchen",
    "affiliateTitle": "Chicken Sausage Breakfast Tacos Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Chicken Sausage Breakfast Tacos from The Prep Kitchen with 13g protein. See nutrition details and check current DFW availability through our affili…",
    "description": "Chicken Sausage Breakfast Tacos is a prepared breakfast option from The Prep Kitchen with 230 calories, 13g protein, 17g carbs, 13g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Chicken Sausage Breakfast Tacos is a prepared breakfast option from The Prep Kitchen with 230 calories, 13g protein, 17g carbs, 13g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "156bb8c5-7b11-44a9-c59c-08dd81f6a044",
    "pradoVariantId": "d4104169-03c2-4f6e-a4c2-08dd81f6a058"
  },
  {
    "name": "Egg White Farmer's Omelette",
    "slug": "egg-white-farmer-s-omelette",
    "category": "Breakfast",
    "badge": null,
    "price": 10.99,
    "calories": 420,
    "fat": 16,
    "carbs": 27,
    "protein": 38,
    "sourceUrl": "https://theprepkitchen.com/product/egg-white-farmers-omelette?pid=396269e5-77fa-4d03-f4ce-08dd81f7b996",
    "imageUrl": "/api/products/images/fitpromeals/products/egg-white-farmer-s-omelette.webp",
    "imageAlt": "Egg White Farmer's Omelette prepared by The Prep Kitchen",
    "affiliateTitle": "Egg White Farmer's Omelette Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Egg White Farmer's Omelette from The Prep Kitchen with 38g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Egg White Farmer's Omelette is a prepared breakfast option from The Prep Kitchen with 420 calories, 38g protein, 27g carbs, 16g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Egg White Farmer's Omelette is a prepared breakfast option from The Prep Kitchen with 420 calories, 38g protein, 27g carbs, 16g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "396269e5-77fa-4d03-f4ce-08dd81f7b996",
    "pradoVariantId": "ac4c6eeb-5592-4da7-aad2-08dd81f7b9a5"
  },
  {
    "name": "PK Classic Protein Pancakes",
    "slug": "pk-classic-protein-pancakes",
    "category": "Breakfast",
    "badge": "BEST SELLER",
    "price": 8.99,
    "calories": 260,
    "fat": 9,
    "carbs": 26,
    "protein": 21,
    "sourceUrl": "https://theprepkitchen.com/product/pk-classic-protein-pancakes?pid=a93c705c-2b3a-459d-fd08-08dd81f6582a",
    "imageUrl": "/api/products/images/fitpromeals/products/pk-classic-protein-pancakes.webp",
    "imageAlt": "PK Classic Protein Pancakes prepared by The Prep Kitchen",
    "affiliateTitle": "PK Classic Protein Pancakes Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PK Classic Protein Pancakes from The Prep Kitchen with 21g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "PK Classic Protein Pancakes is a prepared breakfast option from The Prep Kitchen with 260 calories, 21g protein, 26g carbs, 9g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PK Classic Protein Pancakes is a prepared breakfast option from The Prep Kitchen with 260 calories, 21g protein, 26g carbs, 9g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "a93c705c-2b3a-459d-fd08-08dd81f6582a",
    "pradoVariantId": "436dd5df-d85b-488f-d3b6-08dd81f65832"
  },
  {
    "name": "Whole Egg Farmer's Omelette",
    "slug": "whole-egg-farmer-s-omelette",
    "category": "Breakfast",
    "badge": null,
    "price": 10.99,
    "calories": 610,
    "fat": 38,
    "carbs": 27,
    "protein": 40,
    "sourceUrl": "https://theprepkitchen.com/product/whole-egg-farmers-omelette?pid=caf12782-dccf-4338-59fa-08dd81f7b7df",
    "imageUrl": "/api/products/images/fitpromeals/products/whole-egg-farmer-s-omelette.webp",
    "imageAlt": "Whole Egg Farmer's Omelette prepared by The Prep Kitchen",
    "affiliateTitle": "Whole Egg Farmer's Omelette Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Whole Egg Farmer's Omelette from The Prep Kitchen with 40g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Whole Egg Farmer's Omelette is a prepared breakfast option from The Prep Kitchen with 610 calories, 40g protein, 27g carbs, 38g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Whole Egg Farmer's Omelette is a prepared breakfast option from The Prep Kitchen with 610 calories, 40g protein, 27g carbs, 38g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "caf12782-dccf-4338-59fa-08dd81f7b7df",
    "pradoVariantId": "d6eb79dc-5a40-4bfe-c6fe-08dd81f7b7e6"
  },
  {
    "name": "Scrambled Eggs & Bacon",
    "slug": "scrambled-eggs-and-bacon",
    "category": "Breakfast",
    "badge": null,
    "price": 9.99,
    "calories": 590,
    "fat": 36,
    "carbs": 35,
    "protein": 33,
    "sourceUrl": "https://theprepkitchen.com/product/scrambled-eggs-bacon?pid=56e82644-d635-49c5-5772-08dd81f65929",
    "imageUrl": "/api/products/images/fitpromeals/products/scrambled-eggs-and-bacon.webp",
    "imageAlt": "Scrambled Eggs & Bacon prepared by The Prep Kitchen",
    "affiliateTitle": "Scrambled Eggs & Bacon Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Scrambled Eggs & Bacon from The Prep Kitchen with 33g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Scrambled Eggs & Bacon is a prepared breakfast option from The Prep Kitchen with 590 calories, 33g protein, 35g carbs, 36g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Scrambled Eggs & Bacon is a prepared breakfast option from The Prep Kitchen with 590 calories, 33g protein, 35g carbs, 36g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "56e82644-d635-49c5-5772-08dd81f65929",
    "pradoVariantId": "c3fb3b39-cc6d-4152-90d8-08dd81f65934"
  },
  {
    "name": "Bacon Breakfast Tacos",
    "slug": "bacon-breakfast-tacos",
    "category": "Breakfast",
    "badge": "BEST SELLER",
    "price": 9.99,
    "calories": 230,
    "fat": 14,
    "carbs": 16,
    "protein": 13,
    "sourceUrl": "https://theprepkitchen.com/product/bacon-breakfast-tacos?pid=bc3da5cf-bf9d-479c-a9f0-08dd81f6a192",
    "imageUrl": "/api/products/images/fitpromeals/products/bacon-breakfast-tacos.webp",
    "imageAlt": "Bacon Breakfast Tacos prepared by The Prep Kitchen",
    "affiliateTitle": "Bacon Breakfast Tacos Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Bacon Breakfast Tacos from The Prep Kitchen with 13g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Bacon Breakfast Tacos is a prepared breakfast option from The Prep Kitchen with 230 calories, 13g protein, 16g carbs, 14g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Bacon Breakfast Tacos is a prepared breakfast option from The Prep Kitchen with 230 calories, 13g protein, 16g carbs, 14g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "bc3da5cf-bf9d-479c-a9f0-08dd81f6a192",
    "pradoVariantId": "52e775d6-635f-48fb-b988-08dd81f6a19a"
  },
  {
    "name": "Bison Hash",
    "slug": "bison-hash",
    "category": "Breakfast",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 610,
    "fat": 29,
    "carbs": 47,
    "protein": 47,
    "sourceUrl": "https://theprepkitchen.com/product/bison-hash?pid=492e03a0-7755-44e1-dff8-08dd81f7b666",
    "imageUrl": "/api/products/images/fitpromeals/products/bison-hash.webp",
    "imageAlt": "Bison Hash prepared by The Prep Kitchen",
    "affiliateTitle": "Bison Hash Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Bison Hash from The Prep Kitchen with 47g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Bison Hash is a prepared breakfast option from The Prep Kitchen with 610 calories, 47g protein, 47g carbs, 29g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Bison Hash is a prepared breakfast option from The Prep Kitchen with 610 calories, 47g protein, 47g carbs, 29g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "492e03a0-7755-44e1-dff8-08dd81f7b666",
    "pradoVariantId": "a74831b0-dbdc-430c-59a4-08dd81f7b66e"
  },
  {
    "name": "Fresh Blueberry Protein Pancakes",
    "slug": "fresh-blueberry-protein-pancakes",
    "category": "Breakfast",
    "badge": "BEST SELLER",
    "price": 9.99,
    "calories": 290,
    "fat": 9,
    "carbs": 33,
    "protein": 21,
    "sourceUrl": "https://theprepkitchen.com/product/fresh-blueberry-protein-pancakes?pid=1e364f4e-eabc-4a1c-7fd8-08dd81f6b15b",
    "imageUrl": "/api/products/images/fitpromeals/products/fresh-blueberry-protein-pancakes.webp",
    "imageAlt": "Fresh Blueberry Protein Pancakes prepared by The Prep Kitchen",
    "affiliateTitle": "Fresh Blueberry Protein Pancakes Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Fresh Blueberry Protein Pancakes from The Prep Kitchen with 21g protein. See nutrition details and check current DFW availability through our affil…",
    "description": "Fresh Blueberry Protein Pancakes is a prepared breakfast option from The Prep Kitchen with 290 calories, 21g protein, 33g carbs, 9g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Fresh Blueberry Protein Pancakes is a prepared breakfast option from The Prep Kitchen with 290 calories, 21g protein, 33g carbs, 9g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "1e364f4e-eabc-4a1c-7fd8-08dd81f6b15b",
    "pradoVariantId": "53f5c2ea-5a9b-441f-62fc-08dd81f6b163"
  },
  {
    "name": "Turkey Bacon Wrapped Egg Bites",
    "slug": "turkey-bacon-wrapped-egg-bites",
    "category": "Breakfast",
    "badge": null,
    "price": 9.49,
    "calories": 130,
    "fat": 8,
    "carbs": 1,
    "protein": 12,
    "sourceUrl": "https://theprepkitchen.com/product/turket-bacon-wrapped-egg-bites?pid=cb0c8f0c-3b39-4f82-d3ec-08dd81f65a27",
    "imageUrl": "/api/products/images/fitpromeals/products/turkey-bacon-wrapped-egg-bites.webp",
    "imageAlt": "Turkey Bacon Wrapped Egg Bites prepared by The Prep Kitchen",
    "affiliateTitle": "Turkey Bacon Wrapped Egg Bites Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Turkey Bacon Wrapped Egg Bites from The Prep Kitchen with 12g protein. See nutrition details and check current DFW availability through our affilia…",
    "description": "Turkey Bacon Wrapped Egg Bites is a prepared breakfast option from The Prep Kitchen with 130 calories, 12g protein, 1g carbs, 8g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Turkey Bacon Wrapped Egg Bites is a prepared breakfast option from The Prep Kitchen with 130 calories, 12g protein, 1g carbs, 8g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "cb0c8f0c-3b39-4f82-d3ec-08dd81f65a27",
    "pradoVariantId": "e305d9c8-7690-4400-dee8-08dd81f65a2f"
  },
  {
    "name": "Turkey Feta Whole Egg Omelette",
    "slug": "turkey-feta-whole-egg-omelette",
    "category": "Breakfast",
    "badge": null,
    "price": 9.99,
    "calories": 520,
    "fat": 33,
    "carbs": 7,
    "protein": 48,
    "sourceUrl": "https://theprepkitchen.com/product/turkey-feta-whole-egg-omelette?pid=2c4c98b2-7302-4963-1000-08dd81f6da25",
    "imageUrl": "/api/products/images/fitpromeals/products/turkey-feta-whole-egg-omelette.webp",
    "imageAlt": "Turkey Feta Whole Egg Omelette prepared by The Prep Kitchen",
    "affiliateTitle": "Turkey Feta Whole Egg Omelette Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Turkey Feta Whole Egg Omelette from The Prep Kitchen with 48g protein. See nutrition details and check current DFW availability through our affilia…",
    "description": "Turkey Feta Whole Egg Omelette is a prepared breakfast option from The Prep Kitchen with 520 calories, 48g protein, 7g carbs, 33g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Turkey Feta Whole Egg Omelette is a prepared breakfast option from The Prep Kitchen with 520 calories, 48g protein, 7g carbs, 33g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "2c4c98b2-7302-4963-1000-08dd81f6da25",
    "pradoVariantId": "08c89af2-7c4b-4d2d-26c6-08dd81f6da2f"
  },
  {
    "name": "Turkey Feta Egg White Omelette",
    "slug": "turkey-feta-egg-white-omelette",
    "category": "Breakfast",
    "badge": null,
    "price": 10.99,
    "calories": 300,
    "fat": 9,
    "carbs": 6,
    "protein": 44,
    "sourceUrl": "https://theprepkitchen.com/product/turkey-feta-egg-white-omelette?pid=cd18f364-d0e5-44fc-a9aa-08dd81f6dbd0",
    "imageUrl": "/api/products/images/fitpromeals/products/turkey-feta-egg-white-omelette.webp",
    "imageAlt": "Turkey Feta Egg White Omelette prepared by The Prep Kitchen",
    "affiliateTitle": "Turkey Feta Egg White Omelette Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Turkey Feta Egg White Omelette from The Prep Kitchen with 44g protein. See nutrition details and check current DFW availability through our affilia…",
    "description": "Turkey Feta Egg White Omelette is a prepared breakfast option from The Prep Kitchen with 300 calories, 44g protein, 6g carbs, 9g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Turkey Feta Egg White Omelette is a prepared breakfast option from The Prep Kitchen with 300 calories, 44g protein, 6g carbs, 9g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "cd18f364-d0e5-44fc-a9aa-08dd81f6dbd0",
    "pradoVariantId": "af82010e-f58f-483c-e066-08dd81f6dbdd"
  },
  {
    "name": "Hard Boiled Eggs & Granola Bar",
    "slug": "hard-boiled-eggs-and-granola-bar",
    "category": "Breakfast",
    "badge": null,
    "price": 8.99,
    "calories": 360,
    "fat": 19,
    "carbs": 37,
    "protein": 12,
    "sourceUrl": "https://theprepkitchen.com/product/hard-boiled-eggs-granola-bar?pid=e5bd6e37-4d24-40b5-cf1a-08dd81f65d82",
    "imageUrl": "/api/products/images/fitpromeals/products/hard-boiled-eggs-and-granola-bar.webp",
    "imageAlt": "Hard Boiled Eggs & Granola Bar prepared by The Prep Kitchen",
    "affiliateTitle": "Hard Boiled Eggs & Granola Bar Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Hard Boiled Eggs & Granola Bar from The Prep Kitchen with 12g protein. See nutrition details and check current DFW availability through our affilia…",
    "description": "Hard Boiled Eggs & Granola Bar is a prepared breakfast option from The Prep Kitchen with 360 calories, 12g protein, 37g carbs, 19g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Hard Boiled Eggs & Granola Bar is a prepared breakfast option from The Prep Kitchen with 360 calories, 12g protein, 37g carbs, 19g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "e5bd6e37-4d24-40b5-cf1a-08dd81f65d82",
    "pradoVariantId": "40a2c142-eef9-4f37-a5f4-08dd81f65d8b"
  },
  {
    "name": "Chocolate Chip Protein Muffins - Sweet Addison's",
    "slug": "chocolate-chip-protein-muffins-sweet-addison-s",
    "category": "Breakfast",
    "badge": "BEST SELLER",
    "price": 9.99,
    "calories": 300,
    "fat": 22,
    "carbs": 24,
    "protein": 13,
    "sourceUrl": "https://theprepkitchen.com/product/chocoloate-chip-protein-muffins?pid=a2cb1803-c2be-4fb8-74ae-08dd81f7c6d4",
    "imageUrl": "/api/products/images/fitpromeals/products/chocolate-chip-protein-muffins-sweet-addison-s.webp",
    "imageAlt": "Chocolate Chip Protein Muffins - Sweet Addison's prepared by The Prep Kitchen",
    "affiliateTitle": "Chocolate Chip Protein Muffins - Sweet Addison's Meal in DFW | D…",
    "affiliateMeta": "Review Chocolate Chip Protein Muffins - Sweet Addison's from The Prep Kitchen with 13g protein. See nutrition details and check current DFW availability t…",
    "description": "Chocolate Chip Protein Muffins - Sweet Addison's is a prepared breakfast option from The Prep Kitchen with 300 calories, 13g protein, 24g carbs, 22g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Chocolate Chip Protein Muffins - Sweet Addison's is a prepared breakfast option from The Prep Kitchen with 300 calories, 13g protein, 24g carbs, 22g fat. It is designed for a convenient start to the day without sacrificing a satisfying, balanced meal.",
    "pradoProductId": "a2cb1803-c2be-4fb8-74ae-08dd81f7c6d4",
    "pradoVariantId": "57b1b7ce-3358-4f74-797c-08dd81f7c6de"
  },
  {
    "name": "Chef Sampler",
    "slug": "chef-sampler",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 118.4,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/chef-sampler?pid=9279eb5c-ce68-4917-6868-08dd9c91c62a",
    "imageUrl": "/api/products/images/fitpromeals/products/chef-sampler.webp",
    "imageAlt": "Chef Sampler prepared by The Prep Kitchen",
    "affiliateTitle": "Chef Sampler Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Chef Sampler from The Prep Kitchen. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Chef Sampler is a chef-prepared meal from The Prep Kitchen. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Chef Sampler is a chef-prepared meal from The Prep Kitchen. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "9279eb5c-ce68-4917-6868-08dd9c91c62a",
    "pradoVariantId": "f4b09a49-29fe-4143-d4f4-08dd9c92061c"
  },
  {
    "name": "Low Carb Starter Bag",
    "slug": "low-carb-starter-bag",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 88.92,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/low-carb-starter-bag?pid=fba58d12-4bc4-49df-30a7-08dda7888f7d",
    "imageUrl": "/api/products/images/fitpromeals/products/low-carb-starter-bag.webp",
    "imageAlt": "Low Carb Starter Bag prepared by The Prep Kitchen",
    "affiliateTitle": "Low Carb Starter Bag Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Low Carb Starter Bag from The Prep Kitchen. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Low Carb Starter Bag is a chef-prepared meal from The Prep Kitchen. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Low Carb Starter Bag is a chef-prepared meal from The Prep Kitchen. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "fba58d12-4bc4-49df-30a7-08dda7888f7d",
    "pradoVariantId": "fd44416a-daa0-4582-649e-08dda7888f7d"
  },
  {
    "name": "GLP-1 Meal Bundle",
    "slug": "glp-1-meal-bundle",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 97.42,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/glp-1-meal-bundle?pid=902c32f6-1d3f-40e9-24b1-08ddf558c983",
    "imageUrl": "/api/products/images/fitpromeals/products/glp-1-meal-bundle.webp",
    "imageAlt": "GLP-1 Meal Bundle prepared by The Prep Kitchen",
    "affiliateTitle": "GLP-1 Meal Bundle Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review GLP-1 Meal Bundle from The Prep Kitchen. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "GLP-1 Meal Bundle is a chef-prepared meal from The Prep Kitchen. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "GLP-1 Meal Bundle is a chef-prepared meal from The Prep Kitchen. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "902c32f6-1d3f-40e9-24b1-08ddf558c983",
    "pradoVariantId": "607ad95a-e4ab-45c1-7602-08ddf558c983"
  },
  {
    "name": "Grass-Fed Butter Chicken",
    "slug": "grass-fed-butter-chicken",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 12.99,
    "calories": 500,
    "fat": 18,
    "carbs": 45,
    "protein": 41,
    "sourceUrl": "https://theprepkitchen.com/product/grass-fed-butter-chicken?pid=e4b46638-9c1f-484a-57fc-08deac9e9438",
    "imageUrl": "/api/products/images/fitpromeals/products/grass-fed-butter-chicken.webp",
    "imageAlt": "Grass-Fed Butter Chicken prepared by The Prep Kitchen",
    "affiliateTitle": "Grass-Fed Butter Chicken Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Grass-Fed Butter Chicken from The Prep Kitchen with 41g protein. See nutrition details and check current DFW availability through our affiliate lin…",
    "description": "Grass-Fed Butter Chicken is a chef-prepared meal from The Prep Kitchen with 500 calories, 41g protein, 45g carbs, 18g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Grass-Fed Butter Chicken is a chef-prepared meal from The Prep Kitchen with 500 calories, 41g protein, 45g carbs, 18g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "e4b46638-9c1f-484a-57fc-08deac9e9438",
    "pradoVariantId": "256d0622-1308-42ab-163d-08deac9e959a"
  },
  {
    "name": "Baja Bowl w/ Blackened Chicken",
    "slug": "baja-bowl-w-blackened-chicken",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 12.99,
    "calories": 670,
    "fat": 34,
    "carbs": 50,
    "protein": 42,
    "sourceUrl": "https://theprepkitchen.com/product/baja-bowl-with-blackened-chicken?pid=fb3e5d46-24e9-475b-0035-08de6e52a2b2",
    "imageUrl": "/api/products/images/fitpromeals/products/baja-bowl-w-blackened-chicken.webp",
    "imageAlt": "Baja Bowl w/ Blackened Chicken prepared by The Prep Kitchen",
    "affiliateTitle": "Baja Bowl w/ Blackened Chicken Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Baja Bowl w/ Blackened Chicken from The Prep Kitchen with 42g protein. See nutrition details and check current DFW availability through our affilia…",
    "description": "Baja Bowl w/ Blackened Chicken is a chef-prepared meal from The Prep Kitchen with 670 calories, 42g protein, 50g carbs, 34g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Baja Bowl w/ Blackened Chicken is a chef-prepared meal from The Prep Kitchen with 670 calories, 42g protein, 50g carbs, 34g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "fb3e5d46-24e9-475b-0035-08de6e52a2b2",
    "pradoVariantId": "d97227d0-ef46-4d7b-e630-08de6e52a34a"
  },
  {
    "name": "Pesto Primavera Pasta w/ Chicken",
    "slug": "pesto-primavera-pasta-w-chicken",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 12.99,
    "calories": 680,
    "fat": 35,
    "carbs": 53,
    "protein": 47,
    "sourceUrl": "https://theprepkitchen.com/product/pesto-primavera-pasta-w-chicken?pid=070b1922-3582-4666-f307-08deacaa9a36",
    "imageUrl": "/api/products/images/fitpromeals/products/pesto-primavera-pasta-w-chicken.webp",
    "imageAlt": "Pesto Primavera Pasta w/ Chicken prepared by The Prep Kitchen",
    "affiliateTitle": "Pesto Primavera Pasta w/ Chicken Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Pesto Primavera Pasta w/ Chicken from The Prep Kitchen with 47g protein. See nutrition details and check current DFW availability through our affil…",
    "description": "Pesto Primavera Pasta w/ Chicken is a chef-prepared meal from The Prep Kitchen with 680 calories, 47g protein, 53g carbs, 35g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Pesto Primavera Pasta w/ Chicken is a chef-prepared meal from The Prep Kitchen with 680 calories, 47g protein, 53g carbs, 35g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "070b1922-3582-4666-f307-08deacaa9a36",
    "pradoVariantId": "3c03b155-45d5-426b-39d0-08deacaa9b0f"
  },
  {
    "name": "Penne alla Vodka w/ Chicken",
    "slug": "penne-alla-vodka-w-chicken",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 10.99,
    "calories": 530,
    "fat": 15,
    "carbs": 61,
    "protein": 47,
    "sourceUrl": "https://theprepkitchen.com/product/penne-alla-vodka-with-chicken?pid=2103c975-6c31-4593-540e-08deacad799e",
    "imageUrl": "/api/products/images/fitpromeals/products/penne-alla-vodka-w-chicken.webp",
    "imageAlt": "Penne alla Vodka w/ Chicken prepared by The Prep Kitchen",
    "affiliateTitle": "Penne alla Vodka w/ Chicken Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Penne alla Vodka w/ Chicken from The Prep Kitchen with 47g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Penne alla Vodka w/ Chicken is a chef-prepared meal from The Prep Kitchen with 530 calories, 47g protein, 61g carbs, 15g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Penne alla Vodka w/ Chicken is a chef-prepared meal from The Prep Kitchen with 530 calories, 47g protein, 61g carbs, 15g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "2103c975-6c31-4593-540e-08deacad799e",
    "pradoVariantId": "f6cad684-81e4-499f-af2b-08deacad7ad8"
  },
  {
    "name": "Garlic Herb Chicken w/ Bruschetta",
    "slug": "garlic-herb-chicken-w-bruschetta",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 12.99,
    "calories": 420,
    "fat": 8,
    "carbs": 44,
    "protein": 42,
    "sourceUrl": "https://theprepkitchen.com/product/garlic-herb-chicken-with-bruschetta?pid=ca306714-8096-44d9-91bd-08de6e4640ff",
    "imageUrl": "/api/products/images/fitpromeals/products/garlic-herb-chicken-w-bruschetta.webp",
    "imageAlt": "Garlic Herb Chicken w/ Bruschetta prepared by The Prep Kitchen",
    "affiliateTitle": "Garlic Herb Chicken w/ Bruschetta Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Garlic Herb Chicken w/ Bruschetta from The Prep Kitchen with 42g protein. See nutrition details and check current DFW availability through our affi…",
    "description": "Garlic Herb Chicken w/ Bruschetta is a chef-prepared meal from The Prep Kitchen with 420 calories, 42g protein, 44g carbs, 8g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Garlic Herb Chicken w/ Bruschetta is a chef-prepared meal from The Prep Kitchen with 420 calories, 42g protein, 44g carbs, 8g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "ca306714-8096-44d9-91bd-08de6e4640ff",
    "pradoVariantId": "25f2a19c-0cdc-4a55-a3b9-08de6e4641b3"
  },
  {
    "name": "Mediterranean Bowl",
    "slug": "mediterranean-bowl",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 12.99,
    "calories": 530,
    "fat": 23,
    "carbs": 35,
    "protein": 46,
    "sourceUrl": "https://theprepkitchen.com/product/mediterranean-bowl?pid=6a56bef1-0610-4bb4-0341-08deaca040f2",
    "imageUrl": "/api/products/images/fitpromeals/products/mediterranean-bowl.webp",
    "imageAlt": "Mediterranean Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Mediterranean Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Mediterranean Bowl from The Prep Kitchen with 46g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Mediterranean Bowl is a chef-prepared meal from The Prep Kitchen with 530 calories, 46g protein, 35g carbs, 23g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Mediterranean Bowl is a chef-prepared meal from The Prep Kitchen with 530 calories, 46g protein, 35g carbs, 23g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "6a56bef1-0610-4bb4-0341-08deaca040f2",
    "pradoVariantId": "71766c91-aa82-4a45-44c3-08deaca04130"
  },
  {
    "name": "Chicken Alfredo Pizza",
    "slug": "chicken-alfredo-pizza",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 11.99,
    "calories": 390,
    "fat": 15,
    "carbs": 44,
    "protein": 23,
    "sourceUrl": "https://theprepkitchen.com/product/chicken-alfredo-flatbread-pizza?pid=2939ab55-35e5-49c7-f96a-08de6e4f8d34",
    "imageUrl": "/api/products/images/fitpromeals/products/chicken-alfredo-pizza.webp",
    "imageAlt": "Chicken Alfredo Pizza prepared by The Prep Kitchen",
    "affiliateTitle": "Chicken Alfredo Pizza Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Chicken Alfredo Pizza from The Prep Kitchen with 23g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Chicken Alfredo Pizza is a chef-prepared meal from The Prep Kitchen with 390 calories, 23g protein, 44g carbs, 15g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Chicken Alfredo Pizza is a chef-prepared meal from The Prep Kitchen with 390 calories, 23g protein, 44g carbs, 15g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "2939ab55-35e5-49c7-f96a-08de6e4f8d34",
    "pradoVariantId": "013a3740-3e60-4c5a-642c-08de6e4f8e9e"
  },
  {
    "name": "Primal Turkey Burger",
    "slug": "primal-turkey-burger",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 12.99,
    "calories": 510,
    "fat": 26,
    "carbs": 36,
    "protein": 39,
    "sourceUrl": "https://theprepkitchen.com/product/primal-turkey-burger?pid=1f70de39-5a8d-4280-e4a6-08deacb1d1e2",
    "imageUrl": "/api/products/images/fitpromeals/products/primal-turkey-burger.webp",
    "imageAlt": "Primal Turkey Burger prepared by The Prep Kitchen",
    "affiliateTitle": "Primal Turkey Burger Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Primal Turkey Burger from The Prep Kitchen with 39g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Primal Turkey Burger is a chef-prepared meal from The Prep Kitchen with 510 calories, 39g protein, 36g carbs, 26g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Primal Turkey Burger is a chef-prepared meal from The Prep Kitchen with 510 calories, 39g protein, 36g carbs, 26g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "1f70de39-5a8d-4280-e4a6-08deacb1d1e2",
    "pradoVariantId": "8be030ca-6072-4add-b175-08deacb1d2d5"
  },
  {
    "name": "Salmon w/ Bruschetta",
    "slug": "salmon-w-bruschetta",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 15.99,
    "calories": 560,
    "fat": 24,
    "carbs": 43,
    "protein": 41,
    "sourceUrl": "https://theprepkitchen.com/product/salmon-with-bruschetta?pid=c1fb0762-47a6-4c12-efd6-08deacab93af",
    "imageUrl": "/api/products/images/fitpromeals/products/salmon-w-bruschetta.webp",
    "imageAlt": "Salmon w/ Bruschetta prepared by The Prep Kitchen",
    "affiliateTitle": "Salmon w/ Bruschetta Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Salmon w/ Bruschetta from The Prep Kitchen with 41g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Salmon w/ Bruschetta is a chef-prepared meal from The Prep Kitchen with 560 calories, 41g protein, 43g carbs, 24g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Salmon w/ Bruschetta is a chef-prepared meal from The Prep Kitchen with 560 calories, 41g protein, 43g carbs, 24g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "c1fb0762-47a6-4c12-efd6-08deacab93af",
    "pradoVariantId": "a4a2a722-a195-4144-c2ba-08deacab9471"
  },
  {
    "name": "Steak Tacos",
    "slug": "steak-tacos",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 470,
    "fat": 13,
    "carbs": 50,
    "protein": 42,
    "sourceUrl": "https://theprepkitchen.com/product/steak-tacos?pid=62168fc9-f677-4b3f-7836-08de31fa8ad9",
    "imageUrl": "/api/products/images/fitpromeals/products/steak-tacos.webp",
    "imageAlt": "Steak Tacos prepared by The Prep Kitchen",
    "affiliateTitle": "Steak Tacos Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Steak Tacos from The Prep Kitchen with 42g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Steak Tacos is a chef-prepared meal from The Prep Kitchen with 470 calories, 42g protein, 50g carbs, 13g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Steak Tacos is a chef-prepared meal from The Prep Kitchen with 470 calories, 42g protein, 50g carbs, 13g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "62168fc9-f677-4b3f-7836-08de31fa8ad9",
    "pradoVariantId": "a50ff436-5ded-4b9b-94f6-08de31fa8bb9"
  },
  {
    "name": "Primal Shrimp Tacos",
    "slug": "primal-shrimp-tacos",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 11.99,
    "calories": 530,
    "fat": 15,
    "carbs": 73,
    "protein": 27,
    "sourceUrl": "https://theprepkitchen.com/product/primal-shrimp-tacos?pid=f369e03d-18fb-45a0-e50d-08deaca97047",
    "imageUrl": "/api/products/images/fitpromeals/products/primal-shrimp-tacos.webp",
    "imageAlt": "Primal Shrimp Tacos prepared by The Prep Kitchen",
    "affiliateTitle": "Primal Shrimp Tacos Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Primal Shrimp Tacos from The Prep Kitchen with 27g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Primal Shrimp Tacos is a chef-prepared meal from The Prep Kitchen with 530 calories, 27g protein, 73g carbs, 15g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Primal Shrimp Tacos is a chef-prepared meal from The Prep Kitchen with 530 calories, 27g protein, 73g carbs, 15g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "f369e03d-18fb-45a0-e50d-08deaca97047",
    "pradoVariantId": "c4c87c9c-b086-4d7d-c83d-08deaca97182"
  },
  {
    "name": "Steak Quesadilla",
    "slug": "steak-quesadilla",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 11.99,
    "calories": 270,
    "fat": 15,
    "carbs": 15,
    "protein": 28,
    "sourceUrl": "https://theprepkitchen.com/product/steak-quesadilla?pid=d2c2ace9-884d-46ca-a3ac-08ddefd499a3",
    "imageUrl": "/api/products/images/fitpromeals/products/steak-quesadilla.webp",
    "imageAlt": "Steak Quesadilla prepared by The Prep Kitchen",
    "affiliateTitle": "Steak Quesadilla Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Steak Quesadilla from The Prep Kitchen with 28g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Steak Quesadilla is a chef-prepared meal from The Prep Kitchen with 270 calories, 28g protein, 15g carbs, 15g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Steak Quesadilla is a chef-prepared meal from The Prep Kitchen with 270 calories, 28g protein, 15g carbs, 15g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "d2c2ace9-884d-46ca-a3ac-08ddefd499a3",
    "pradoVariantId": "8b2952a1-8e76-4f00-cd42-08ddefd49a04"
  },
  {
    "name": "Buffalo Chicken Wrap",
    "slug": "buffalo-chicken-wrap",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 9.99,
    "calories": 460,
    "fat": 16,
    "carbs": 29,
    "protein": 50,
    "sourceUrl": "https://theprepkitchen.com/product/buffalo-chicken-wrap?pid=06e4db3c-e9af-4beb-ed46-08de31d7feaf",
    "imageUrl": "/api/products/images/fitpromeals/products/buffalo-chicken-wrap.webp",
    "imageAlt": "Buffalo Chicken Wrap prepared by The Prep Kitchen",
    "affiliateTitle": "Buffalo Chicken Wrap Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Buffalo Chicken Wrap from The Prep Kitchen with 50g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Buffalo Chicken Wrap is a chef-prepared meal from The Prep Kitchen with 460 calories, 50g protein, 29g carbs, 16g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Buffalo Chicken Wrap is a chef-prepared meal from The Prep Kitchen with 460 calories, 50g protein, 29g carbs, 16g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "06e4db3c-e9af-4beb-ed46-08de31d7feaf",
    "pradoVariantId": "3aeb06a2-997c-4171-c24f-08de31d7ff6b"
  },
  {
    "name": "Chicken Tinga Bowl",
    "slug": "chicken-tinga-bowl",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 11.99,
    "calories": 470,
    "fat": 12,
    "carbs": 58,
    "protein": 32,
    "sourceUrl": "https://theprepkitchen.com/product/chicken-tinga-bowl?pid=5b9f84ba-d7ef-48bb-b917-08de31f2922c",
    "imageUrl": "/api/products/images/fitpromeals/products/chicken-tinga-bowl.webp",
    "imageAlt": "Chicken Tinga Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Chicken Tinga Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Chicken Tinga Bowl from The Prep Kitchen with 32g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Chicken Tinga Bowl is a chef-prepared meal from The Prep Kitchen with 470 calories, 32g protein, 58g carbs, 12g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Chicken Tinga Bowl is a chef-prepared meal from The Prep Kitchen with 470 calories, 32g protein, 58g carbs, 12g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "5b9f84ba-d7ef-48bb-b917-08de31f2922c",
    "pradoVariantId": "59c66cc7-7dcf-4a67-528e-08de31f29338"
  },
  {
    "name": "Cheeseburger Bowl",
    "slug": "cheeseburger-bowl",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 12.99,
    "calories": 780,
    "fat": 43,
    "carbs": 56,
    "protein": 41,
    "sourceUrl": "https://theprepkitchen.com/product/cheeseburger-bowl?pid=c7833d9a-3b05-4466-128a-08de31d1015a",
    "imageUrl": "/api/products/images/fitpromeals/products/cheeseburger-bowl.webp",
    "imageAlt": "Cheeseburger Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Cheeseburger Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Cheeseburger Bowl from The Prep Kitchen with 41g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Cheeseburger Bowl is a chef-prepared meal from The Prep Kitchen with 780 calories, 41g protein, 56g carbs, 43g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Cheeseburger Bowl is a chef-prepared meal from The Prep Kitchen with 780 calories, 41g protein, 56g carbs, 43g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "c7833d9a-3b05-4466-128a-08de31d1015a",
    "pradoVariantId": "18a910e0-b7bc-4b47-a099-08de31d10296"
  },
  {
    "name": "PK Hamburger Helper",
    "slug": "pk-hamburger-helper",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 9.99,
    "calories": 570,
    "fat": 25,
    "carbs": 49,
    "protein": 43,
    "sourceUrl": "https://theprepkitchen.com/product/pk-hamburger-helper?pid=cb0ebae3-238c-44d6-e96f-08de32a2c00a",
    "imageUrl": "/api/products/images/fitpromeals/products/pk-hamburger-helper.webp",
    "imageAlt": "PK Hamburger Helper prepared by The Prep Kitchen",
    "affiliateTitle": "PK Hamburger Helper Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PK Hamburger Helper from The Prep Kitchen with 43g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "PK Hamburger Helper is a chef-prepared meal from The Prep Kitchen with 570 calories, 43g protein, 49g carbs, 25g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PK Hamburger Helper is a chef-prepared meal from The Prep Kitchen with 570 calories, 43g protein, 49g carbs, 25g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "cb0ebae3-238c-44d6-e96f-08de32a2c00a",
    "pradoVariantId": "c4b64c30-501f-417d-0e6f-08de32a2c14a"
  },
  {
    "name": "Teriyaki Chicken Stir Fry Bowl",
    "slug": "teriyaki-chicken-stir-fry-bowl",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 490,
    "fat": 7,
    "carbs": 65,
    "protein": 35,
    "sourceUrl": "https://theprepkitchen.com/product/teriyaki-chicken-stir-fry-bowl?pid=0525c03f-3c35-4b82-7530-08ddefc78ee9",
    "imageUrl": "/api/products/images/fitpromeals/products/teriyaki-chicken-stir-fry-bowl.webp",
    "imageAlt": "Teriyaki Chicken Stir Fry Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Teriyaki Chicken Stir Fry Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Teriyaki Chicken Stir Fry Bowl from The Prep Kitchen with 35g protein. See nutrition details and check current DFW availability through our affilia…",
    "description": "Teriyaki Chicken Stir Fry Bowl is a chef-prepared meal from The Prep Kitchen with 490 calories, 35g protein, 65g carbs, 7g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Teriyaki Chicken Stir Fry Bowl is a chef-prepared meal from The Prep Kitchen with 490 calories, 35g protein, 65g carbs, 7g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "0525c03f-3c35-4b82-7530-08ddefc78ee9",
    "pradoVariantId": "95f30999-b8eb-4df4-d3d7-08ddefc78f2e"
  },
  {
    "name": "Teriyaki Steak Stir Fry Bowl",
    "slug": "teriyaki-steak-stir-fry-bowl",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 13.99,
    "calories": 520,
    "fat": 11,
    "carbs": 64,
    "protein": 38,
    "sourceUrl": "https://theprepkitchen.com/product/teriyaki-steak-stir-fry-bowl?pid=7490440c-2fd4-4f4f-4ecc-08ddefc08002",
    "imageUrl": "/api/products/images/fitpromeals/products/teriyaki-steak-stir-fry-bowl.webp",
    "imageAlt": "Teriyaki Steak Stir Fry Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Teriyaki Steak Stir Fry Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Teriyaki Steak Stir Fry Bowl from The Prep Kitchen with 38g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Teriyaki Steak Stir Fry Bowl is a chef-prepared meal from The Prep Kitchen with 520 calories, 38g protein, 64g carbs, 11g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Teriyaki Steak Stir Fry Bowl is a chef-prepared meal from The Prep Kitchen with 520 calories, 38g protein, 64g carbs, 11g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "7490440c-2fd4-4f4f-4ecc-08ddefc08002",
    "pradoVariantId": "5f766bdb-eeeb-4023-b7db-08ddefc080b4"
  },
  {
    "name": "Sesame Teriyaki Salmon",
    "slug": "sesame-teriyaki-salmon",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 15.99,
    "calories": 700,
    "fat": 28,
    "carbs": 65,
    "protein": 42,
    "sourceUrl": "https://theprepkitchen.com/product/sesame-teriyaki-salmon?pid=db7739ba-f5b8-4f4c-c8b4-08dd861a19e0",
    "imageUrl": "/api/products/images/fitpromeals/products/sesame-teriyaki-salmon.webp",
    "imageAlt": "Sesame Teriyaki Salmon prepared by The Prep Kitchen",
    "affiliateTitle": "Sesame Teriyaki Salmon Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Sesame Teriyaki Salmon from The Prep Kitchen with 42g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Sesame Teriyaki Salmon is a chef-prepared meal from The Prep Kitchen with 700 calories, 42g protein, 65g carbs, 28g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Sesame Teriyaki Salmon is a chef-prepared meal from The Prep Kitchen with 700 calories, 42g protein, 65g carbs, 28g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "db7739ba-f5b8-4f4c-c8b4-08dd861a19e0",
    "pradoVariantId": "d20c2b35-8d4a-4940-32c6-08dd861a19e1"
  },
  {
    "name": "Grilled Chicken Caesar Wrap",
    "slug": "grilled-chicken-caesar-wrap",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 9.99,
    "calories": 650,
    "fat": 41,
    "carbs": 26,
    "protein": 48,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-chicken-caesar-wrap?pid=3ec387d2-3b3e-4456-524d-08de6b543df4",
    "imageUrl": "/api/products/images/fitpromeals/products/grilled-chicken-caesar-wrap.webp",
    "imageAlt": "Grilled Chicken Caesar Wrap prepared by The Prep Kitchen",
    "affiliateTitle": "Grilled Chicken Caesar Wrap Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Grilled Chicken Caesar Wrap from The Prep Kitchen with 48g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Grilled Chicken Caesar Wrap is a chef-prepared meal from The Prep Kitchen with 650 calories, 48g protein, 26g carbs, 41g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Grilled Chicken Caesar Wrap is a chef-prepared meal from The Prep Kitchen with 650 calories, 48g protein, 26g carbs, 41g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "3ec387d2-3b3e-4456-524d-08de6b543df4",
    "pradoVariantId": "4263c280-6d4f-4fb1-edf3-08de6b543f4c"
  },
  {
    "name": "Cajun Chicken w/ Mac & Cheese",
    "slug": "cajun-chicken-w-mac-and-cheese",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 11.99,
    "calories": 500,
    "fat": 21,
    "carbs": 30,
    "protein": 50,
    "sourceUrl": "https://theprepkitchen.com/product/cajun-chicken-with-mac-cheese?pid=01133aa4-8e8e-4bc3-e23b-08de6e4c0b22",
    "imageUrl": "/api/products/images/fitpromeals/products/cajun-chicken-w-mac-and-cheese.webp",
    "imageAlt": "Cajun Chicken w/ Mac & Cheese prepared by The Prep Kitchen",
    "affiliateTitle": "Cajun Chicken w/ Mac & Cheese Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Cajun Chicken w/ Mac & Cheese from The Prep Kitchen with 50g protein. See nutrition details and check current DFW availability through our affiliat…",
    "description": "Cajun Chicken w/ Mac & Cheese is a chef-prepared meal from The Prep Kitchen with 500 calories, 50g protein, 30g carbs, 21g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Cajun Chicken w/ Mac & Cheese is a chef-prepared meal from The Prep Kitchen with 500 calories, 50g protein, 30g carbs, 21g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "01133aa4-8e8e-4bc3-e23b-08de6e4c0b22",
    "pradoVariantId": "2afc706e-7b24-477e-2913-08de6e4c0c15"
  },
  {
    "name": "BBQ Cheddar Bison Burger",
    "slug": "bbq-cheddar-bison-burger",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 14.99,
    "calories": 720,
    "fat": 38,
    "carbs": 53,
    "protein": 44,
    "sourceUrl": "https://theprepkitchen.com/product/bbq-cheddar-bison-burger?pid=a7c5d0d6-9050-4a13-0f86-08de6e4894cb",
    "imageUrl": "/api/products/images/fitpromeals/products/bbq-cheddar-bison-burger.webp",
    "imageAlt": "BBQ Cheddar Bison Burger prepared by The Prep Kitchen",
    "affiliateTitle": "BBQ Cheddar Bison Burger Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review BBQ Cheddar Bison Burger from The Prep Kitchen with 44g protein. See nutrition details and check current DFW availability through our affiliate lin…",
    "description": "BBQ Cheddar Bison Burger is a chef-prepared meal from The Prep Kitchen with 720 calories, 44g protein, 53g carbs, 38g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "BBQ Cheddar Bison Burger is a chef-prepared meal from The Prep Kitchen with 720 calories, 44g protein, 53g carbs, 38g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "a7c5d0d6-9050-4a13-0f86-08de6e4894cb",
    "pradoVariantId": "fb5fdf03-8005-4e6e-6b03-08de6e4895cf"
  },
  {
    "name": "Chicken Tortilla Soup",
    "slug": "chicken-tortilla-soup",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 8.99,
    "calories": 170,
    "fat": 8,
    "carbs": 11,
    "protein": 14,
    "sourceUrl": "https://theprepkitchen.com/product/chicken-tortilla-soup?pid=f80fa449-1281-4a05-c4b0-08dd81f6d682",
    "imageUrl": "/api/products/images/fitpromeals/products/chicken-tortilla-soup.webp",
    "imageAlt": "Chicken Tortilla Soup prepared by The Prep Kitchen",
    "affiliateTitle": "Chicken Tortilla Soup Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Chicken Tortilla Soup from The Prep Kitchen with 14g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Chicken Tortilla Soup is a chef-prepared meal from The Prep Kitchen with 170 calories, 14g protein, 11g carbs, 8g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Chicken Tortilla Soup is a chef-prepared meal from The Prep Kitchen with 170 calories, 14g protein, 11g carbs, 8g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "f80fa449-1281-4a05-c4b0-08dd81f6d682",
    "pradoVariantId": "3dab8cc8-306b-4cd1-b282-08dd81f6d68b"
  },
  {
    "name": "Grilled Chicken Quesadilla",
    "slug": "grilled-chicken-quesadilla",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 10.99,
    "calories": 250,
    "fat": 13,
    "carbs": 15,
    "protein": 26,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-chicken-quesadilla?pid=48a91879-667f-4ee5-bc22-08dd81f7d43d",
    "imageUrl": "/api/products/images/fitpromeals/products/grilled-chicken-quesadilla.webp",
    "imageAlt": "Grilled Chicken Quesadilla prepared by The Prep Kitchen",
    "affiliateTitle": "Grilled Chicken Quesadilla Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Grilled Chicken Quesadilla from The Prep Kitchen with 26g protein. See nutrition details and check current DFW availability through our affiliate l…",
    "description": "Grilled Chicken Quesadilla is a chef-prepared meal from The Prep Kitchen with 250 calories, 26g protein, 15g carbs, 13g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Grilled Chicken Quesadilla is a chef-prepared meal from The Prep Kitchen with 250 calories, 26g protein, 15g carbs, 13g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "48a91879-667f-4ee5-bc22-08dd81f7d43d",
    "pradoVariantId": "4acc9f64-9f63-41a4-f73e-08dd81f7d445"
  },
  {
    "name": "Beef Burrito",
    "slug": "beef-burrito",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 10.99,
    "calories": 510,
    "fat": 18,
    "carbs": 62,
    "protein": 41,
    "sourceUrl": "https://theprepkitchen.com/product/beef-burrito?pid=cf4d45e8-cab7-4595-f21c-08ddefcd630f",
    "imageUrl": "/api/products/images/fitpromeals/products/beef-burrito.webp",
    "imageAlt": "Beef Burrito prepared by The Prep Kitchen",
    "affiliateTitle": "Beef Burrito Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Beef Burrito from The Prep Kitchen with 41g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Beef Burrito is a chef-prepared meal from The Prep Kitchen with 510 calories, 41g protein, 62g carbs, 18g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Beef Burrito is a chef-prepared meal from The Prep Kitchen with 510 calories, 41g protein, 62g carbs, 18g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "cf4d45e8-cab7-4595-f21c-08ddefcd630f",
    "pradoVariantId": "6005536c-d3a1-44f3-088c-08ddefcd63a1"
  },
  {
    "name": "Turkey Pesto Wrap",
    "slug": "turkey-pesto-wrap",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 9.99,
    "calories": 460,
    "fat": 23,
    "carbs": 30,
    "protein": 34,
    "sourceUrl": "https://theprepkitchen.com/product/turkey-pesto-wrap?pid=7f7a44ac-8584-4ddd-81b8-08dd81f7cfd2",
    "imageUrl": "/api/products/images/fitpromeals/products/turkey-pesto-wrap.webp",
    "imageAlt": "Turkey Pesto Wrap prepared by The Prep Kitchen",
    "affiliateTitle": "Turkey Pesto Wrap Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Turkey Pesto Wrap from The Prep Kitchen with 34g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Turkey Pesto Wrap is a chef-prepared meal from The Prep Kitchen with 460 calories, 34g protein, 30g carbs, 23g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Turkey Pesto Wrap is a chef-prepared meal from The Prep Kitchen with 460 calories, 34g protein, 30g carbs, 23g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "7f7a44ac-8584-4ddd-81b8-08dd81f7cfd2",
    "pradoVariantId": "479cd4d1-8ac2-4c86-dd34-08dd81f7cfdc"
  },
  {
    "name": "Cajun Shrimp Pasta",
    "slug": "cajun-shrimp-pasta",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 13.49,
    "calories": 440,
    "fat": 13,
    "carbs": 53,
    "protein": 36,
    "sourceUrl": "https://theprepkitchen.com/product/creamy-cajun-shrimp-pasta?pid=a827bb1a-a2bc-4c10-4eea-08ddf0840ecf",
    "imageUrl": "/api/products/images/fitpromeals/products/cajun-shrimp-pasta.webp",
    "imageAlt": "Cajun Shrimp Pasta prepared by The Prep Kitchen",
    "affiliateTitle": "Cajun Shrimp Pasta Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Cajun Shrimp Pasta from The Prep Kitchen with 36g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Cajun Shrimp Pasta is a chef-prepared meal from The Prep Kitchen with 440 calories, 36g protein, 53g carbs, 13g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Cajun Shrimp Pasta is a chef-prepared meal from The Prep Kitchen with 440 calories, 36g protein, 53g carbs, 13g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "a827bb1a-a2bc-4c10-4eea-08ddf0840ecf",
    "pradoVariantId": "f1ec1a0e-2a92-4d80-d49f-08ddf0840f79"
  },
  {
    "name": "PK Chicken Tenders with Mac & Cheese",
    "slug": "pk-chicken-tenders-with-mac-and-cheese",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 600,
    "fat": 25,
    "carbs": 51,
    "protein": 50,
    "sourceUrl": "https://theprepkitchen.com/product/pk-chicken-tenders-mac-cheese?pid=0cbe9897-cdac-4590-b93a-08dd81f7403a",
    "imageUrl": "/api/products/images/fitpromeals/products/pk-chicken-tenders-with-mac-and-cheese.webp",
    "imageAlt": "PK Chicken Tenders with Mac & Cheese prepared by The Prep Kitchen",
    "affiliateTitle": "PK Chicken Tenders with Mac & Cheese Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PK Chicken Tenders with Mac & Cheese from The Prep Kitchen with 50g protein. See nutrition details and check current DFW availability through our a…",
    "description": "PK Chicken Tenders with Mac & Cheese is a chef-prepared meal from The Prep Kitchen with 600 calories, 50g protein, 51g carbs, 25g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PK Chicken Tenders with Mac & Cheese is a chef-prepared meal from The Prep Kitchen with 600 calories, 50g protein, 51g carbs, 25g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "0cbe9897-cdac-4590-b93a-08dd81f7403a",
    "pradoVariantId": "7c251809-f97b-41df-bfd6-08dd81f74042"
  },
  {
    "name": "Bacon Cheeseburger w/ Whole Grain Bun",
    "slug": "bacon-cheeseburger-w-whole-grain-bun",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 11.99,
    "calories": 370,
    "fat": 20,
    "carbs": 21,
    "protein": 28,
    "sourceUrl": "https://theprepkitchen.com/product/bacon-cheeseburger-whole-grain-bun?pid=b3c52cbb-3e05-425c-a90e-08dd81f7560b",
    "imageUrl": "/api/products/images/fitpromeals/products/bacon-cheeseburger-w-whole-grain-bun.webp",
    "imageAlt": "Bacon Cheeseburger w/ Whole Grain Bun prepared by The Prep Kitchen",
    "affiliateTitle": "Bacon Cheeseburger w/ Whole Grain Bun Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Bacon Cheeseburger w/ Whole Grain Bun from The Prep Kitchen with 28g protein. See nutrition details and check current DFW availability through our…",
    "description": "Bacon Cheeseburger w/ Whole Grain Bun is a chef-prepared meal from The Prep Kitchen with 370 calories, 28g protein, 21g carbs, 20g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Bacon Cheeseburger w/ Whole Grain Bun is a chef-prepared meal from The Prep Kitchen with 370 calories, 28g protein, 21g carbs, 20g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "b3c52cbb-3e05-425c-a90e-08dd81f7560b",
    "pradoVariantId": "eaf4ef02-1684-468d-ff9c-08dd81f75612"
  },
  {
    "name": "Sausage & Mushroom Pizza",
    "slug": "sausage-and-mushroom-pizza",
    "category": "Lunch & Dinner",
    "badge": "NEW",
    "price": 11.49,
    "calories": 350,
    "fat": 16,
    "carbs": 43,
    "protein": 13,
    "sourceUrl": "https://theprepkitchen.com/product/sausage-mushroom-flatbread-pizza?pid=3a071c48-fccf-40d1-325e-08dd81f78ed1",
    "imageUrl": "/api/products/images/fitpromeals/products/sausage-and-mushroom-pizza.webp",
    "imageAlt": "Sausage & Mushroom Pizza prepared by The Prep Kitchen",
    "affiliateTitle": "Sausage & Mushroom Pizza Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Sausage & Mushroom Pizza from The Prep Kitchen with 13g protein. See nutrition details and check current DFW availability through our affiliate lin…",
    "description": "Sausage & Mushroom Pizza is a chef-prepared meal from The Prep Kitchen with 350 calories, 13g protein, 43g carbs, 16g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Sausage & Mushroom Pizza is a chef-prepared meal from The Prep Kitchen with 350 calories, 13g protein, 43g carbs, 16g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "3a071c48-fccf-40d1-325e-08dd81f78ed1",
    "pradoVariantId": "f6725f55-84a2-4847-8d66-08dd81f78ee6"
  },
  {
    "name": "Buffalo Chicken Mac & Cheese",
    "slug": "buffalo-chicken-mac-and-cheese",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 10.99,
    "calories": 640,
    "fat": 29,
    "carbs": 39,
    "protein": 59,
    "sourceUrl": "https://theprepkitchen.com/product/buffalo-chicken-mac-cheese?pid=3a5ab1fa-b635-4ffd-b50f-08ddefcec6dc",
    "imageUrl": "/api/products/images/fitpromeals/products/buffalo-chicken-mac-and-cheese.webp",
    "imageAlt": "Buffalo Chicken Mac & Cheese prepared by The Prep Kitchen",
    "affiliateTitle": "Buffalo Chicken Mac & Cheese Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Buffalo Chicken Mac & Cheese from The Prep Kitchen with 59g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Buffalo Chicken Mac & Cheese is a chef-prepared meal from The Prep Kitchen with 640 calories, 59g protein, 39g carbs, 29g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Buffalo Chicken Mac & Cheese is a chef-prepared meal from The Prep Kitchen with 640 calories, 59g protein, 39g carbs, 29g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "3a5ab1fa-b635-4ffd-b50f-08ddefcec6dc",
    "pradoVariantId": "50055182-e819-476d-a77b-08ddefcec78e"
  },
  {
    "name": "Chicken Fried Rice",
    "slug": "chicken-fried-rice",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 340,
    "fat": 4,
    "carbs": 46,
    "protein": 26,
    "sourceUrl": "https://theprepkitchen.com/product/chicken-fried-rice?pid=2f915936-c120-486e-92fa-08dd67f137b7",
    "imageUrl": "/api/products/images/fitpromeals/products/chicken-fried-rice.webp",
    "imageAlt": "Chicken Fried Rice prepared by The Prep Kitchen",
    "affiliateTitle": "Chicken Fried Rice Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Chicken Fried Rice from The Prep Kitchen with 26g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Chicken Fried Rice is a chef-prepared meal from The Prep Kitchen with 340 calories, 26g protein, 46g carbs, 4g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Chicken Fried Rice is a chef-prepared meal from The Prep Kitchen with 340 calories, 26g protein, 46g carbs, 4g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "2f915936-c120-486e-92fa-08dd67f137b7",
    "pradoVariantId": "8bb1ccd3-d5af-4069-9ad7-08dd67f137b7"
  },
  {
    "name": "Shrimp Fried Rice",
    "slug": "shrimp-fried-rice",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 13.99,
    "calories": 300,
    "fat": 3,
    "carbs": 47,
    "protein": 21,
    "sourceUrl": "https://theprepkitchen.com/product/shrimp-fried-rice?pid=f46c9ad6-5eff-44ad-dd8e-08dd81f6b7be",
    "imageUrl": "/api/products/images/fitpromeals/products/shrimp-fried-rice.webp",
    "imageAlt": "Shrimp Fried Rice prepared by The Prep Kitchen",
    "affiliateTitle": "Shrimp Fried Rice Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Shrimp Fried Rice from The Prep Kitchen with 21g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Shrimp Fried Rice is a chef-prepared meal from The Prep Kitchen with 300 calories, 21g protein, 47g carbs, 3g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Shrimp Fried Rice is a chef-prepared meal from The Prep Kitchen with 300 calories, 21g protein, 47g carbs, 3g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "f46c9ad6-5eff-44ad-dd8e-08dd81f6b7be",
    "pradoVariantId": "a16f1f03-3833-4999-e3e8-08dd81f6b7c7"
  },
  {
    "name": "Tofu Fried Rice",
    "slug": "tofu-fried-rice",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 11.99,
    "calories": 580,
    "fat": 33,
    "carbs": 52,
    "protein": 23,
    "sourceUrl": "https://theprepkitchen.com/product/tofu-fried-rice?pid=3ad8db22-f346-4dc7-ea60-08dd81f6b8f2",
    "imageUrl": "/api/products/images/fitpromeals/products/tofu-fried-rice.webp",
    "imageAlt": "Tofu Fried Rice prepared by The Prep Kitchen",
    "affiliateTitle": "Tofu Fried Rice Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Tofu Fried Rice from The Prep Kitchen with 23g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Tofu Fried Rice is a chef-prepared meal from The Prep Kitchen with 580 calories, 23g protein, 52g carbs, 33g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Tofu Fried Rice is a chef-prepared meal from The Prep Kitchen with 580 calories, 23g protein, 52g carbs, 33g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "3ad8db22-f346-4dc7-ea60-08dd81f6b8f2",
    "pradoVariantId": "d8995182-406a-4f58-75ec-08dd81f6b8fe"
  },
  {
    "name": "PK Chicken Enchiladas",
    "slug": "pk-chicken-enchiladas",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 380,
    "fat": 8,
    "carbs": 53,
    "protein": 22,
    "sourceUrl": "https://theprepkitchen.com/product/pk-chicken-enchiladas?pid=5453a4be-bcff-4bd5-6734-08dd81f6bf4b",
    "imageUrl": "/api/products/images/fitpromeals/products/pk-chicken-enchiladas.webp",
    "imageAlt": "PK Chicken Enchiladas prepared by The Prep Kitchen",
    "affiliateTitle": "PK Chicken Enchiladas Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PK Chicken Enchiladas from The Prep Kitchen with 22g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "PK Chicken Enchiladas is a chef-prepared meal from The Prep Kitchen with 380 calories, 22g protein, 53g carbs, 8g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PK Chicken Enchiladas is a chef-prepared meal from The Prep Kitchen with 380 calories, 22g protein, 53g carbs, 8g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "5453a4be-bcff-4bd5-6734-08dd81f6bf4b",
    "pradoVariantId": "361aecad-2644-4295-4c48-08dd81f6bf57"
  },
  {
    "name": "Buffalo Chicken Meal",
    "slug": "buffalo-chicken-meal",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 450,
    "fat": 17,
    "carbs": 31,
    "protein": 45,
    "sourceUrl": "https://theprepkitchen.com/product/buffalo-chicken-meal?pid=e18bfed1-1439-427a-91b4-08dd81f6c0a4",
    "imageUrl": "/api/products/images/fitpromeals/products/buffalo-chicken-meal.webp",
    "imageAlt": "Buffalo Chicken Meal prepared by The Prep Kitchen",
    "affiliateTitle": "Buffalo Chicken Meal Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Buffalo Chicken Meal from The Prep Kitchen with 45g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Buffalo Chicken Meal is a chef-prepared meal from The Prep Kitchen with 450 calories, 45g protein, 31g carbs, 17g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Buffalo Chicken Meal is a chef-prepared meal from The Prep Kitchen with 450 calories, 45g protein, 31g carbs, 17g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "e18bfed1-1439-427a-91b4-08dd81f6c0a4",
    "pradoVariantId": "ce0498fe-c3cd-45a3-06ba-08dd81f6c0ac"
  },
  {
    "name": "Grilled Chicken Burrito Bowl",
    "slug": "grilled-chicken-burrito-bowl",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 12.99,
    "calories": 500,
    "fat": 7,
    "carbs": 65,
    "protein": 45,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-chicken-burrito-bowl?pid=e318d817-f8e2-45d4-8e54-08dd81f6ba36",
    "imageUrl": "/api/products/images/fitpromeals/products/grilled-chicken-burrito-bowl.webp",
    "imageAlt": "Grilled Chicken Burrito Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Grilled Chicken Burrito Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Grilled Chicken Burrito Bowl from The Prep Kitchen with 45g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Grilled Chicken Burrito Bowl is a chef-prepared meal from The Prep Kitchen with 500 calories, 45g protein, 65g carbs, 7g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Grilled Chicken Burrito Bowl is a chef-prepared meal from The Prep Kitchen with 500 calories, 45g protein, 65g carbs, 7g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "e318d817-f8e2-45d4-8e54-08dd81f6ba36",
    "pradoVariantId": "67fded18-a321-4725-5c38-08dd81f6ba3e"
  },
  {
    "name": "Grilled Steak Burrito Bowl",
    "slug": "grilled-steak-burrito-bowl",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 13.99,
    "calories": 540,
    "fat": 10,
    "carbs": 65,
    "protein": 48,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-steak-burrito-browl?pid=59dc5832-269f-4f4b-4eea-08dd81f6bcc4",
    "imageUrl": "/api/products/images/fitpromeals/products/grilled-steak-burrito-bowl.webp",
    "imageAlt": "Grilled Steak Burrito Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Grilled Steak Burrito Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Grilled Steak Burrito Bowl from The Prep Kitchen with 48g protein. See nutrition details and check current DFW availability through our affiliate l…",
    "description": "Grilled Steak Burrito Bowl is a chef-prepared meal from The Prep Kitchen with 540 calories, 48g protein, 65g carbs, 10g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Grilled Steak Burrito Bowl is a chef-prepared meal from The Prep Kitchen with 540 calories, 48g protein, 65g carbs, 10g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "59dc5832-269f-4f4b-4eea-08dd81f6bcc4",
    "pradoVariantId": "678b6dfb-95b6-422f-287c-08dd81f6bccc"
  },
  {
    "name": "Ground Turkey Burrito Bowl",
    "slug": "ground-turkey-burrito-bowl",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 470,
    "fat": 9,
    "carbs": 64,
    "protein": 42,
    "sourceUrl": "https://theprepkitchen.com/product/ground-turkey-burrito-bowl?pid=0b493b63-96c9-4874-8bf8-08dd81f6bb7a",
    "imageUrl": "/api/products/images/fitpromeals/products/ground-turkey-burrito-bowl.webp",
    "imageAlt": "Ground Turkey Burrito Bowl prepared by The Prep Kitchen",
    "affiliateTitle": "Ground Turkey Burrito Bowl Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Ground Turkey Burrito Bowl from The Prep Kitchen with 42g protein. See nutrition details and check current DFW availability through our affiliate l…",
    "description": "Ground Turkey Burrito Bowl is a chef-prepared meal from The Prep Kitchen with 470 calories, 42g protein, 64g carbs, 9g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Ground Turkey Burrito Bowl is a chef-prepared meal from The Prep Kitchen with 470 calories, 42g protein, 64g carbs, 9g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "0b493b63-96c9-4874-8bf8-08dd81f6bb7a",
    "pradoVariantId": "f52ac1df-d909-4a82-e894-08dd81f6bb81"
  },
  {
    "name": "Homemade Beef Meatballs and Pasta Marinara",
    "slug": "homemade-beef-meatballs-and-pasta-marinara",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.99,
    "calories": 400,
    "fat": 21,
    "carbs": 35,
    "protein": 24,
    "sourceUrl": "https://theprepkitchen.com/product/homemade-meatballs-pasta?pid=c49a6980-1c14-4a81-87fc-08dd81f6a3dd",
    "imageUrl": "/api/products/images/fitpromeals/products/homemade-beef-meatballs-and-pasta-marinara.webp",
    "imageAlt": "Homemade Beef Meatballs and Pasta Marinara prepared by The Prep Kitchen",
    "affiliateTitle": "Homemade Beef Meatballs and Pasta Marinara Meal in DFW | DFW Fit…",
    "affiliateMeta": "Review Homemade Beef Meatballs and Pasta Marinara from The Prep Kitchen with 24g protein. See nutrition details and check current DFW availability through…",
    "description": "Homemade Beef Meatballs and Pasta Marinara is a chef-prepared meal from The Prep Kitchen with 400 calories, 24g protein, 35g carbs, 21g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Homemade Beef Meatballs and Pasta Marinara is a chef-prepared meal from The Prep Kitchen with 400 calories, 24g protein, 35g carbs, 21g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "c49a6980-1c14-4a81-87fc-08dd81f6a3dd",
    "pradoVariantId": "8dd3da29-5ec9-49af-c19c-08dd81f6a3e5"
  },
  {
    "name": "Petite Filet Mignon w/ PK Steak Sauce",
    "slug": "petite-filet-mignon-w-pk-steak-sauce",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 25.99,
    "calories": 390,
    "fat": 12,
    "carbs": 36,
    "protein": 35,
    "sourceUrl": "https://theprepkitchen.com/product/petit-filet-mignon?pid=9c293ec9-044d-4a71-afc6-08dd81f6646c",
    "imageUrl": "/api/products/images/fitpromeals/products/petite-filet-mignon-w-pk-steak-sauce.webp",
    "imageAlt": "Petite Filet Mignon w/ PK Steak Sauce prepared by The Prep Kitchen",
    "affiliateTitle": "Petite Filet Mignon w/ PK Steak Sauce Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Petite Filet Mignon w/ PK Steak Sauce from The Prep Kitchen with 35g protein. See nutrition details and check current DFW availability through our…",
    "description": "Petite Filet Mignon w/ PK Steak Sauce is a chef-prepared meal from The Prep Kitchen with 390 calories, 35g protein, 36g carbs, 12g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Petite Filet Mignon w/ PK Steak Sauce is a chef-prepared meal from The Prep Kitchen with 390 calories, 35g protein, 36g carbs, 12g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "9c293ec9-044d-4a71-afc6-08dd81f6646c",
    "pradoVariantId": "c3c9f556-2fff-425f-9100-08dd81f66474"
  },
  {
    "name": "#01 Grilled Chicken, Sweet Potatoes & Zucchini",
    "slug": "01-grilled-chicken-sweet-potatoes-and-zucchini",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 13.99,
    "calories": 640,
    "fat": 20,
    "carbs": 54,
    "protein": 58,
    "sourceUrl": "https://theprepkitchen.com/product/prefixed-1grilled-chicken-sweet-potatoes?pid=3c86b80f-bd71-40ce-8442-08dd81f5f7ed",
    "imageUrl": "/api/products/images/fitpromeals/products/01-grilled-chicken-sweet-potatoes-and-zucchini.webp",
    "imageAlt": "#01 Grilled Chicken, Sweet Potatoes & Zucchini prepared by The Prep Kitchen",
    "affiliateTitle": "#01 Grilled Chicken, Sweet Potatoes & Zucchini Meal in DFW | DFW…",
    "affiliateMeta": "Review #01 Grilled Chicken, Sweet Potatoes & Zucchini from The Prep Kitchen with 58g protein. See nutrition details and check current DFW availability thr…",
    "description": "#01 Grilled Chicken, Sweet Potatoes & Zucchini is a chef-prepared meal from The Prep Kitchen with 640 calories, 58g protein, 54g carbs, 20g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#01 Grilled Chicken, Sweet Potatoes & Zucchini is a chef-prepared meal from The Prep Kitchen with 640 calories, 58g protein, 54g carbs, 20g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "3c86b80f-bd71-40ce-8442-08dd81f5f7ed",
    "pradoVariantId": "faa0a39a-6d76-4ff5-f484-08dd81f5f7f4"
  },
  {
    "name": "#02 Ground Turkey, Jasmine Rice & Green Beans",
    "slug": "02-ground-turkey-jasmine-rice-and-green-beans",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 11.99,
    "calories": 560,
    "fat": 10,
    "carbs": 71,
    "protein": 55,
    "sourceUrl": "https://theprepkitchen.com/product/prefixed-ground-turkey-jasmine-rice?pid=c9c24da2-0378-4965-424c-08dd81f5f938",
    "imageUrl": "/api/products/images/fitpromeals/products/02-ground-turkey-jasmine-rice-and-green-beans.webp",
    "imageAlt": "#02 Ground Turkey, Jasmine Rice & Green Beans prepared by The Prep Kitchen",
    "affiliateTitle": "#02 Ground Turkey, Jasmine Rice & Green Beans Meal in DFW | DFW…",
    "affiliateMeta": "Review #02 Ground Turkey, Jasmine Rice & Green Beans from The Prep Kitchen with 55g protein. See nutrition details and check current DFW availability thro…",
    "description": "#02 Ground Turkey, Jasmine Rice & Green Beans is a chef-prepared meal from The Prep Kitchen with 560 calories, 55g protein, 71g carbs, 10g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#02 Ground Turkey, Jasmine Rice & Green Beans is a chef-prepared meal from The Prep Kitchen with 560 calories, 55g protein, 71g carbs, 10g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "c9c24da2-0378-4965-424c-08dd81f5f938",
    "pradoVariantId": "3402d0f4-97d4-42c8-a392-08dd81f5f940"
  },
  {
    "name": "#04 Ground Beef, Brown Rice & Roasted Broccoli",
    "slug": "04-ground-beef-brown-rice-and-roasted-broccoli",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 12.49,
    "calories": 540,
    "fat": 19,
    "carbs": 44,
    "protein": 49,
    "sourceUrl": "https://theprepkitchen.com/product/ground-beef-brown-rice-broccoli?pid=84ba02d8-5ca2-4183-c2bc-08dd81f5fc26",
    "imageUrl": "/api/products/images/fitpromeals/products/04-ground-beef-brown-rice-and-roasted-broccoli.webp",
    "imageAlt": "#04 Ground Beef, Brown Rice & Roasted Broccoli prepared by The Prep Kitchen",
    "affiliateTitle": "#04 Ground Beef, Brown Rice & Roasted Broccoli Meal in DFW | DFW…",
    "affiliateMeta": "Review #04 Ground Beef, Brown Rice & Roasted Broccoli from The Prep Kitchen with 49g protein. See nutrition details and check current DFW availability thr…",
    "description": "#04 Ground Beef, Brown Rice & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 540 calories, 49g protein, 44g carbs, 19g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#04 Ground Beef, Brown Rice & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 540 calories, 49g protein, 44g carbs, 19g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "84ba02d8-5ca2-4183-c2bc-08dd81f5fc26",
    "pradoVariantId": "618a2b29-0fa8-49e2-c034-08dd81f5fc2e"
  },
  {
    "name": "#05 Ground Turkey, Cauliflower Mash & Mushrooms",
    "slug": "05-ground-turkey-cauliflower-mash-and-mushrooms",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 12.49,
    "calories": 370,
    "fat": 24,
    "carbs": 13,
    "protein": 37,
    "sourceUrl": "https://theprepkitchen.com/product/ground-turkey-cauliflower-mash-mushroom?pid=c04c40d8-6130-484f-7370-08dd81f5fa73",
    "imageUrl": "/api/products/images/fitpromeals/products/05-ground-turkey-cauliflower-mash-and-mushrooms.webp",
    "imageAlt": "#05 Ground Turkey, Cauliflower Mash & Mushrooms prepared by The Prep Kitchen",
    "affiliateTitle": "#05 Ground Turkey, Cauliflower Mash & Mushrooms Meal in DFW | DF…",
    "affiliateMeta": "Review #05 Ground Turkey, Cauliflower Mash & Mushrooms from The Prep Kitchen with 37g protein. See nutrition details and check current DFW availability th…",
    "description": "#05 Ground Turkey, Cauliflower Mash & Mushrooms is a chef-prepared meal from The Prep Kitchen with 370 calories, 37g protein, 13g carbs, 24g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#05 Ground Turkey, Cauliflower Mash & Mushrooms is a chef-prepared meal from The Prep Kitchen with 370 calories, 37g protein, 13g carbs, 24g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "c04c40d8-6130-484f-7370-08dd81f5fa73",
    "pradoVariantId": "bf2b98ab-d2e0-470d-d01a-08dd81f5fa7b"
  },
  {
    "name": "#06 Grilled Chicken, Red Potatoes & Roasted Broccoli",
    "slug": "06-grilled-chicken-red-potatoes-and-roasted-broccoli",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 12.49,
    "calories": 390,
    "fat": 10,
    "carbs": 35,
    "protein": 41,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-chicken-red-potatoes-broccoli?pid=8fa4a222-b08c-4b5f-6112-08dd81f5ff07",
    "imageUrl": "/api/products/images/fitpromeals/products/06-grilled-chicken-red-potatoes-and-roasted-broccoli.webp",
    "imageAlt": "#06 Grilled Chicken, Red Potatoes & Roasted Broccoli prepared by The Prep Kitchen",
    "affiliateTitle": "#06 Grilled Chicken, Red Potatoes & Roasted Broccoli Meal in DFW…",
    "affiliateMeta": "Review #06 Grilled Chicken, Red Potatoes & Roasted Broccoli from The Prep Kitchen with 41g protein. See nutrition details and check current DFW availabili…",
    "description": "#06 Grilled Chicken, Red Potatoes & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 390 calories, 41g protein, 35g carbs, 10g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#06 Grilled Chicken, Red Potatoes & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 390 calories, 41g protein, 35g carbs, 10g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "8fa4a222-b08c-4b5f-6112-08dd81f5ff07",
    "pradoVariantId": "572d7d6d-f300-4b08-b808-08dd81f5ff14"
  },
  {
    "name": "#07 Salmon, Cauliflower Mash & Roasted Broccoli",
    "slug": "07-salmon-cauliflower-mash-and-roasted-broccoli",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 14.99,
    "calories": 510,
    "fat": 33,
    "carbs": 15,
    "protein": 40,
    "sourceUrl": "https://theprepkitchen.com/product/salmon-cauliflower-mash-broccoli?pid=7e20153e-7658-453d-8410-08dd81f69806",
    "imageUrl": "/api/products/images/fitpromeals/products/07-salmon-cauliflower-mash-and-roasted-broccoli.webp",
    "imageAlt": "#07 Salmon, Cauliflower Mash & Roasted Broccoli prepared by The Prep Kitchen",
    "affiliateTitle": "#07 Salmon, Cauliflower Mash & Roasted Broccoli Meal in DFW | DF…",
    "affiliateMeta": "Review #07 Salmon, Cauliflower Mash & Roasted Broccoli from The Prep Kitchen with 40g protein. See nutrition details and check current DFW availability th…",
    "description": "#07 Salmon, Cauliflower Mash & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 510 calories, 40g protein, 15g carbs, 33g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#07 Salmon, Cauliflower Mash & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 510 calories, 40g protein, 15g carbs, 33g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "7e20153e-7658-453d-8410-08dd81f69806",
    "pradoVariantId": "4753bdd7-64c2-4538-16e4-08dd81f6980e"
  },
  {
    "name": "#08 Steak, Sweet Potatoes & Zucchini",
    "slug": "08-steak-sweet-potatoes-and-zucchini",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 14.49,
    "calories": 490,
    "fat": 19,
    "carbs": 38,
    "protein": 43,
    "sourceUrl": "https://theprepkitchen.com/product/steak-sweet-potatoes-zucchini?pid=09a59683-e069-4dce-b8dc-08dd81f60237",
    "imageUrl": "/api/products/images/fitpromeals/products/08-steak-sweet-potatoes-and-zucchini.webp",
    "imageAlt": "#08 Steak, Sweet Potatoes & Zucchini prepared by The Prep Kitchen",
    "affiliateTitle": "#08 Steak, Sweet Potatoes & Zucchini Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review #08 Steak, Sweet Potatoes & Zucchini from The Prep Kitchen with 43g protein. See nutrition details and check current DFW availability through our a…",
    "description": "#08 Steak, Sweet Potatoes & Zucchini is a chef-prepared meal from The Prep Kitchen with 490 calories, 43g protein, 38g carbs, 19g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#08 Steak, Sweet Potatoes & Zucchini is a chef-prepared meal from The Prep Kitchen with 490 calories, 43g protein, 38g carbs, 19g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "09a59683-e069-4dce-b8dc-08dd81f60237",
    "pradoVariantId": "a93fc144-5867-4879-e62e-08dd81f6023f"
  },
  {
    "name": "#10 Shrimp, Jasmine Rice & Roasted Broccoli",
    "slug": "10-shrimp-jasmine-rice-and-roasted-broccoli",
    "category": "Lunch & Dinner",
    "badge": "BEST SELLER",
    "price": 13.49,
    "calories": 370,
    "fat": 4,
    "carbs": 52,
    "protein": 33,
    "sourceUrl": "https://theprepkitchen.com/product/shrimp-jasmine-rice-broccoli?pid=7677b48a-f194-46dc-0628-08dd81f60564",
    "imageUrl": "/api/products/images/fitpromeals/products/10-shrimp-jasmine-rice-and-roasted-broccoli.webp",
    "imageAlt": "#10 Shrimp, Jasmine Rice & Roasted Broccoli prepared by The Prep Kitchen",
    "affiliateTitle": "#10 Shrimp, Jasmine Rice & Roasted Broccoli Meal in DFW | DFW Fi…",
    "affiliateMeta": "Review #10 Shrimp, Jasmine Rice & Roasted Broccoli from The Prep Kitchen with 33g protein. See nutrition details and check current DFW availability throug…",
    "description": "#10 Shrimp, Jasmine Rice & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 370 calories, 33g protein, 52g carbs, 4g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#10 Shrimp, Jasmine Rice & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 370 calories, 33g protein, 52g carbs, 4g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "7677b48a-f194-46dc-0628-08dd81f60564",
    "pradoVariantId": "2191597b-f339-446f-beea-08dd81f6056b"
  },
  {
    "name": "#14 Salmon & Brussel Sprouts",
    "slug": "14-salmon-and-brussel-sprouts",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 13.99,
    "calories": 460,
    "fat": 30,
    "carbs": 11,
    "protein": 38,
    "sourceUrl": "https://theprepkitchen.com/product/salmon-brussel-sprouts?pid=f7d20e0f-421a-4e0a-a5e6-08dd81f60ad8",
    "imageUrl": "/api/products/images/fitpromeals/products/14-salmon-and-brussel-sprouts.webp",
    "imageAlt": "#14 Salmon & Brussel Sprouts prepared by The Prep Kitchen",
    "affiliateTitle": "#14 Salmon & Brussel Sprouts Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review #14 Salmon & Brussel Sprouts from The Prep Kitchen with 38g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "#14 Salmon & Brussel Sprouts is a chef-prepared meal from The Prep Kitchen with 460 calories, 38g protein, 11g carbs, 30g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#14 Salmon & Brussel Sprouts is a chef-prepared meal from The Prep Kitchen with 460 calories, 38g protein, 11g carbs, 30g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "f7d20e0f-421a-4e0a-a5e6-08dd81f60ad8",
    "pradoVariantId": "30941f74-d106-47de-d7fc-08dd81f60ae0"
  },
  {
    "name": "#16 Steak, Red Potatoes & Green Beans",
    "slug": "16-steak-red-potatoes-and-green-beans",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 14.99,
    "calories": 410,
    "fat": 12,
    "carbs": 33,
    "protein": 43,
    "sourceUrl": "https://theprepkitchen.com/product/steak-read-potatoes-green-beans?pid=ae0c3417-9f05-4c0a-ff44-08dd81f60dff",
    "imageUrl": "/api/products/images/fitpromeals/products/16-steak-red-potatoes-and-green-beans.webp",
    "imageAlt": "#16 Steak, Red Potatoes & Green Beans prepared by The Prep Kitchen",
    "affiliateTitle": "#16 Steak, Red Potatoes & Green Beans Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review #16 Steak, Red Potatoes & Green Beans from The Prep Kitchen with 43g protein. See nutrition details and check current DFW availability through our…",
    "description": "#16 Steak, Red Potatoes & Green Beans is a chef-prepared meal from The Prep Kitchen with 410 calories, 43g protein, 33g carbs, 12g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#16 Steak, Red Potatoes & Green Beans is a chef-prepared meal from The Prep Kitchen with 410 calories, 43g protein, 33g carbs, 12g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "ae0c3417-9f05-4c0a-ff44-08dd81f60dff",
    "pradoVariantId": "7cfbf15c-6369-4396-5c94-08dd81f60e07"
  },
  {
    "name": "#17 Grilled Chicken, Sweet Potatoes & Brussel Sprouts",
    "slug": "17-grilled-chicken-sweet-potatoes-and-brussel-sprouts",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 11.99,
    "calories": 490,
    "fat": 17,
    "carbs": 44,
    "protein": 41,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-chicken-sweet-potatoes-brussels?pid=5316e4c2-21ae-4bde-f048-08dd81f60f31",
    "imageUrl": "/api/products/images/fitpromeals/products/17-grilled-chicken-sweet-potatoes-and-brussel-sprouts.webp",
    "imageAlt": "#17 Grilled Chicken, Sweet Potatoes & Brussel Sprouts prepared by The Prep Kitchen",
    "affiliateTitle": "#17 Grilled Chicken, Sweet Potatoes & Brussel Sprouts Meal in DF…",
    "affiliateMeta": "Review #17 Grilled Chicken, Sweet Potatoes & Brussel Sprouts from The Prep Kitchen with 41g protein. See nutrition details and check current DFW availabil…",
    "description": "#17 Grilled Chicken, Sweet Potatoes & Brussel Sprouts is a chef-prepared meal from The Prep Kitchen with 490 calories, 41g protein, 44g carbs, 17g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#17 Grilled Chicken, Sweet Potatoes & Brussel Sprouts is a chef-prepared meal from The Prep Kitchen with 490 calories, 41g protein, 44g carbs, 17g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "5316e4c2-21ae-4bde-f048-08dd81f60f31",
    "pradoVariantId": "0789c90e-1e0a-40bf-ddda-08dd81f60f39"
  },
  {
    "name": "#24 Grilled Chicken, Red Skin Mashed Potatoes & Asparagus",
    "slug": "24-grilled-chicken-red-skin-mashed-potatoes-and-asparagus",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 13.49,
    "calories": 320,
    "fat": 7,
    "carbs": 24,
    "protein": 40,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-chicken-mashed-potatoes-asparagus?pid=025efa53-7ff0-40db-fcae-08dd81f6e772",
    "imageUrl": "/api/products/images/fitpromeals/products/24-grilled-chicken-red-skin-mashed-potatoes-and-asparagus.webp",
    "imageAlt": "#24 Grilled Chicken, Red Skin Mashed Potatoes & Asparagus prepared by The Prep Kitchen",
    "affiliateTitle": "#24 Grilled Chicken, Red Skin Mashed Potatoes & Asparagus Meal i…",
    "affiliateMeta": "Review #24 Grilled Chicken, Red Skin Mashed Potatoes & Asparagus from The Prep Kitchen with 40g protein. See nutrition details and check current DFW avail…",
    "description": "#24 Grilled Chicken, Red Skin Mashed Potatoes & Asparagus is a chef-prepared meal from The Prep Kitchen with 320 calories, 40g protein, 24g carbs, 7g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#24 Grilled Chicken, Red Skin Mashed Potatoes & Asparagus is a chef-prepared meal from The Prep Kitchen with 320 calories, 40g protein, 24g carbs, 7g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "025efa53-7ff0-40db-fcae-08dd81f6e772",
    "pradoVariantId": "ca79c1fc-a871-43c2-8316-08dd81f6e77f"
  },
  {
    "name": "#25 Turkey Breast, Red Skin Mashed Potatoes & Roasted Broccoli",
    "slug": "25-turkey-breast-red-skin-mashed-potatoes-and-roasted-broccoli",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 12.49,
    "calories": 350,
    "fat": 10,
    "carbs": 28,
    "protein": 38,
    "sourceUrl": "https://theprepkitchen.com/product/turkey-breast-mashed-potatoes-broccoli?pid=19338bc1-2acc-4947-98a6-08dd81f6e8e2",
    "imageUrl": "/api/products/images/fitpromeals/products/25-turkey-breast-red-skin-mashed-potatoes-and-roasted-broccoli.webp",
    "imageAlt": "#25 Turkey Breast, Red Skin Mashed Potatoes & Roasted Broccoli prepared by The Prep Kitchen",
    "affiliateTitle": "#25 Turkey Breast, Red Skin Mashed Potatoes & Roasted Broccoli M…",
    "affiliateMeta": "Review #25 Turkey Breast, Red Skin Mashed Potatoes & Roasted Broccoli from The Prep Kitchen with 38g protein. See nutrition details and check current DFW…",
    "description": "#25 Turkey Breast, Red Skin Mashed Potatoes & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 350 calories, 38g protein, 28g carbs, 10g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#25 Turkey Breast, Red Skin Mashed Potatoes & Roasted Broccoli is a chef-prepared meal from The Prep Kitchen with 350 calories, 38g protein, 28g carbs, 10g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "19338bc1-2acc-4947-98a6-08dd81f6e8e2",
    "pradoVariantId": "330f8594-bb6e-4b40-2fe4-08dd81f6e8ef"
  },
  {
    "name": "#32 Ground Bison, Sweet Potato Mash & Brussel Sprouts",
    "slug": "32-ground-bison-sweet-potato-mash-and-brussel-sprouts",
    "category": "Lunch & Dinner",
    "badge": null,
    "price": 14.99,
    "calories": 450,
    "fat": 18,
    "carbs": 43,
    "protein": 40,
    "sourceUrl": "https://theprepkitchen.com/product/ground-bison-sweet-potatoes-brussels?pid=0eb88efb-8e8f-44a2-5d46-08dd81f6f53f",
    "imageUrl": "/api/products/images/fitpromeals/products/32-ground-bison-sweet-potato-mash-and-brussel-sprouts.webp",
    "imageAlt": "#32 Ground Bison, Sweet Potato Mash & Brussel Sprouts prepared by The Prep Kitchen",
    "affiliateTitle": "#32 Ground Bison, Sweet Potato Mash & Brussel Sprouts Meal in DF…",
    "affiliateMeta": "Review #32 Ground Bison, Sweet Potato Mash & Brussel Sprouts from The Prep Kitchen with 40g protein. See nutrition details and check current DFW availabil…",
    "description": "#32 Ground Bison, Sweet Potato Mash & Brussel Sprouts is a chef-prepared meal from The Prep Kitchen with 450 calories, 40g protein, 43g carbs, 18g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "#32 Ground Bison, Sweet Potato Mash & Brussel Sprouts is a chef-prepared meal from The Prep Kitchen with 450 calories, 40g protein, 43g carbs, 18g fat. It offers a convenient way to keep lunch or dinner flavorful, portioned, and ready when you are.",
    "pradoProductId": "0eb88efb-8e8f-44a2-5d46-08dd81f6f53f",
    "pradoVariantId": "b80d10bd-5eaa-416f-ba62-08dd81f6f548"
  },
  {
    "name": "Family Bundle Box",
    "slug": "family-bundle-box",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 109.99,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/family-bulk-box?pid=cf0a0137-ba54-482f-ec9f-08dd98abcef7",
    "imageUrl": "/api/products/images/fitpromeals/products/family-bundle-box.webp",
    "imageAlt": "Family Bundle Box prepared by The Prep Kitchen",
    "affiliateTitle": "Family Bundle Box Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Family Bundle Box from The Prep Kitchen. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Family Bundle Box is a ready-to-serve bulk protein or side from The Prep Kitchen. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Family Bundle Box is a ready-to-serve bulk protein or side from The Prep Kitchen. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "cf0a0137-ba54-482f-ec9f-08dd98abcef7",
    "pradoVariantId": "ed261a8a-38b4-46de-1224-08dd98abcf05"
  },
  {
    "name": "Garlic Herb Chicken Bites 16 oz",
    "slug": "garlic-herb-chicken-bites-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": "NEW",
    "price": 19.99,
    "calories": 210,
    "fat": 6,
    "carbs": 1,
    "protein": 35,
    "sourceUrl": "https://theprepkitchen.com/product/garlic-herb-chicken-bites-16oz?pid=b0caf3e7-9866-4c13-ba96-08de69a29d33",
    "imageUrl": "/api/products/images/fitpromeals/products/garlic-herb-chicken-bites-16-oz.webp",
    "imageAlt": "Garlic Herb Chicken Bites 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Garlic Herb Chicken Bites 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Garlic Herb Chicken Bites 16 oz from The Prep Kitchen with 35g protein. See nutrition details and check current DFW availability through our affili…",
    "description": "Garlic Herb Chicken Bites 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 210 calories, 35g protein, 1g carbs, 6g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Garlic Herb Chicken Bites 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 210 calories, 35g protein, 1g carbs, 6g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "b0caf3e7-9866-4c13-ba96-08de69a29d33",
    "pradoVariantId": "c4110dbf-72dc-4a36-97e4-08de69a29d98"
  },
  {
    "name": "Blackened Chicken Thighs 16 oz",
    "slug": "blackened-chicken-thighs-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 19.99,
    "calories": 210,
    "fat": 8,
    "carbs": 0,
    "protein": 33,
    "sourceUrl": "https://theprepkitchen.com/product/blackened-chicken-thighs-16oz?pid=4a4a4419-367a-4b98-25d4-08de6e4e9675",
    "imageUrl": "/api/products/images/fitpromeals/products/blackened-chicken-thighs-16-oz.webp",
    "imageAlt": "Blackened Chicken Thighs 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Blackened Chicken Thighs 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Blackened Chicken Thighs 16 oz from The Prep Kitchen with 33g protein. See nutrition details and check current DFW availability through our affilia…",
    "description": "Blackened Chicken Thighs 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 210 calories, 33g protein, 0g carbs, 8g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Blackened Chicken Thighs 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 210 calories, 33g protein, 0g carbs, 8g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "4a4a4419-367a-4b98-25d4-08de6e4e9675",
    "pradoVariantId": "d7508f24-da55-44d8-cfed-08de6e4e971d"
  },
  {
    "name": "All-Natural Chicken Breast 16 oz",
    "slug": "all-natural-chicken-breast-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": "BEST SELLER",
    "price": 19.99,
    "calories": 190,
    "fat": 4,
    "carbs": 1,
    "protein": 35,
    "sourceUrl": "https://theprepkitchen.com/product/all-natural-chicken-breast?pid=2e85d92e-2ccc-47e4-b314-08dd81f5cbfa",
    "imageUrl": "/api/products/images/fitpromeals/products/all-natural-chicken-breast-16-oz.webp",
    "imageAlt": "All-Natural Chicken Breast 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "All-Natural Chicken Breast 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review All-Natural Chicken Breast 16 oz from The Prep Kitchen with 35g protein. See nutrition details and check current DFW availability through our affil…",
    "description": "All-Natural Chicken Breast 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 190 calories, 35g protein, 1g carbs, 4g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "All-Natural Chicken Breast 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 190 calories, 35g protein, 1g carbs, 4g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "2e85d92e-2ccc-47e4-b314-08dd81f5cbfa",
    "pradoVariantId": "0fb547ee-81f4-4ce7-1f52-08dd81f5cc05"
  },
  {
    "name": "Shredded Chicken Tinga 16oz",
    "slug": "shredded-chicken-tinga-16oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 18.99,
    "calories": 180,
    "fat": 5,
    "carbs": 4,
    "protein": 29,
    "sourceUrl": "https://theprepkitchen.com/product/shredded-chicken-tinga-16oz?pid=a9e4d47c-47ed-4188-f052-08de31fd73cd",
    "imageUrl": "/api/products/images/fitpromeals/products/shredded-chicken-tinga-16oz.webp",
    "imageAlt": "Shredded Chicken Tinga 16oz prepared by The Prep Kitchen",
    "affiliateTitle": "Shredded Chicken Tinga 16oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Shredded Chicken Tinga 16oz from The Prep Kitchen with 29g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Shredded Chicken Tinga 16oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 180 calories, 29g protein, 4g carbs, 5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Shredded Chicken Tinga 16oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 180 calories, 29g protein, 4g carbs, 5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "a9e4d47c-47ed-4188-f052-08de31fd73cd",
    "pradoVariantId": "5a32992b-27f6-4c1b-16c1-08de31fd73eb"
  },
  {
    "name": "Certified Angus Lean Ground Beef 16 oz",
    "slug": "certified-angus-lean-ground-beef-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 19.99,
    "calories": 220,
    "fat": 11,
    "carbs": 1,
    "protein": 28,
    "sourceUrl": "https://theprepkitchen.com/product/certified-angus-lean-ground-beef?pid=d073bc26-74a6-47f6-8a4e-08dd81f5cf40",
    "imageUrl": "/api/products/images/fitpromeals/products/certified-angus-lean-ground-beef-16-oz.webp",
    "imageAlt": "Certified Angus Lean Ground Beef 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Certified Angus Lean Ground Beef 16 oz Meal in DFW | DFW Fit Mea…",
    "affiliateMeta": "Review Certified Angus Lean Ground Beef 16 oz from The Prep Kitchen with 28g protein. See nutrition details and check current DFW availability through our…",
    "description": "Certified Angus Lean Ground Beef 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 220 calories, 28g protein, 1g carbs, 11g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Certified Angus Lean Ground Beef 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 220 calories, 28g protein, 1g carbs, 11g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "d073bc26-74a6-47f6-8a4e-08dd81f5cf40",
    "pradoVariantId": "b86477e3-fda8-451f-acce-08dd81f5cf48"
  },
  {
    "name": "All-Natural Lean Turkey 16 oz",
    "slug": "all-natural-lean-turkey-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": "BEST SELLER",
    "price": 18.99,
    "calories": 170,
    "fat": 6,
    "carbs": 1,
    "protein": 32,
    "sourceUrl": "https://theprepkitchen.com/product/all-natural-lean-turkey?pid=5f78e22f-028f-42e5-fa1c-08dd81f5d097",
    "imageUrl": "/api/products/images/fitpromeals/products/all-natural-lean-turkey-16-oz.webp",
    "imageAlt": "All-Natural Lean Turkey 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "All-Natural Lean Turkey 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review All-Natural Lean Turkey 16 oz from The Prep Kitchen with 32g protein. See nutrition details and check current DFW availability through our affiliat…",
    "description": "All-Natural Lean Turkey 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 170 calories, 32g protein, 1g carbs, 6g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "All-Natural Lean Turkey 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 170 calories, 32g protein, 1g carbs, 6g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "5f78e22f-028f-42e5-fa1c-08dd81f5d097",
    "pradoVariantId": "69b592f3-ca7b-459f-6d06-08dd81f5d09f"
  },
  {
    "name": "All-Natural Lean Bison 16 oz",
    "slug": "all-natural-lean-bison-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": "BEST SELLER",
    "price": 31.99,
    "calories": 220,
    "fat": 8,
    "carbs": 2,
    "protein": 35,
    "sourceUrl": "https://theprepkitchen.com/product/all-natural-lean-bison?pid=a817e533-e0e2-4ee5-63a8-08dd81f5d57a",
    "imageUrl": "/api/products/images/fitpromeals/products/all-natural-lean-bison-16-oz.webp",
    "imageAlt": "All-Natural Lean Bison 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "All-Natural Lean Bison 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review All-Natural Lean Bison 16 oz from The Prep Kitchen with 35g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "All-Natural Lean Bison 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 220 calories, 35g protein, 2g carbs, 8g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "All-Natural Lean Bison 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 220 calories, 35g protein, 2g carbs, 8g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "a817e533-e0e2-4ee5-63a8-08dd81f5d57a",
    "pradoVariantId": "344818e3-766e-4f00-c2de-08dd81f5d585"
  },
  {
    "name": "PK Grilled Shrimp 16 oz",
    "slug": "pk-grilled-shrimp-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 30.99,
    "calories": 130,
    "fat": 2,
    "carbs": 2,
    "protein": 26,
    "sourceUrl": "https://theprepkitchen.com/product/pk-grilled-shrimp?pid=d80aed4f-d0e8-4b89-cafe-08dd81f5d2ec",
    "imageUrl": "/api/products/images/fitpromeals/products/pk-grilled-shrimp-16-oz.webp",
    "imageAlt": "PK Grilled Shrimp 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "PK Grilled Shrimp 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PK Grilled Shrimp 16 oz from The Prep Kitchen with 26g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "PK Grilled Shrimp 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 130 calories, 26g protein, 2g carbs, 2.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PK Grilled Shrimp 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 130 calories, 26g protein, 2g carbs, 2.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "d80aed4f-d0e8-4b89-cafe-08dd81f5d2ec",
    "pradoVariantId": "2677d68b-c8cb-4c7d-639e-08dd81f5d2f5"
  },
  {
    "name": "Certified Angus Steak Tender 16 oz",
    "slug": "certified-angus-steak-tender-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 31.99,
    "calories": 230,
    "fat": 8,
    "carbs": 1,
    "protein": 39,
    "sourceUrl": "https://theprepkitchen.com/product/certified-angus-steak-tender?pid=dbfd2f95-82d1-4906-84e8-08dd81f5d41a",
    "imageUrl": "/api/products/images/fitpromeals/products/certified-angus-steak-tender-16-oz.webp",
    "imageAlt": "Certified Angus Steak Tender 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Certified Angus Steak Tender 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Certified Angus Steak Tender 16 oz from The Prep Kitchen with 39g protein. See nutrition details and check current DFW availability through our aff…",
    "description": "Certified Angus Steak Tender 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 230 calories, 39g protein, 1g carbs, 8g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Certified Angus Steak Tender 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 230 calories, 39g protein, 1g carbs, 8g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "dbfd2f95-82d1-4906-84e8-08dd81f5d41a",
    "pradoVariantId": "eb6fa20b-4d96-4cd0-6916-08dd81f5d426"
  },
  {
    "name": "Buffalo Chicken Bites 16 oz",
    "slug": "buffalo-chicken-bites-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": "BEST SELLER",
    "price": 19.99,
    "calories": 220,
    "fat": 7,
    "carbs": 1,
    "protein": 35,
    "sourceUrl": "https://theprepkitchen.com/product/buffalo-chicken-bites?pid=714b26d0-0e03-4735-971e-08ddf0867769",
    "imageUrl": "/api/products/images/fitpromeals/products/buffalo-chicken-bites-16-oz.webp",
    "imageAlt": "Buffalo Chicken Bites 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Buffalo Chicken Bites 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Buffalo Chicken Bites 16 oz from The Prep Kitchen with 35g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Buffalo Chicken Bites 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 220 calories, 35g protein, 1g carbs, 7g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Buffalo Chicken Bites 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 220 calories, 35g protein, 1g carbs, 7g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "714b26d0-0e03-4735-971e-08ddf0867769",
    "pradoVariantId": "ac616142-46fe-4b1a-ef87-08ddf08677fc"
  },
  {
    "name": "PK Chicken Tenders 16 oz",
    "slug": "pk-chicken-tenders-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 19.99,
    "calories": 250,
    "fat": 19,
    "carbs": 16,
    "protein": 27,
    "sourceUrl": "https://theprepkitchen.com/product/pk-chicken-tenders?pid=77851c94-2e34-4ffe-f38c-08dd81f74b20",
    "imageUrl": "/api/products/images/fitpromeals/products/pk-chicken-tenders-16-oz.webp",
    "imageAlt": "PK Chicken Tenders 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "PK Chicken Tenders 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PK Chicken Tenders 16 oz from The Prep Kitchen with 27g protein. See nutrition details and check current DFW availability through our affiliate lin…",
    "description": "PK Chicken Tenders 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 250 calories, 27g protein, 16g carbs, 19g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PK Chicken Tenders 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 250 calories, 27g protein, 16g carbs, 19g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "77851c94-2e34-4ffe-f38c-08dd81f74b20",
    "pradoVariantId": "ce925acf-30bb-4e0f-2036-08dd81f74b36"
  },
  {
    "name": "Turkey Breast 16 oz",
    "slug": "turkey-breast-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 19.99,
    "calories": 200,
    "fat": 6,
    "carbs": 2,
    "protein": 33,
    "sourceUrl": "https://theprepkitchen.com/product/turkey-breast?pid=2439d86e-8ea4-4998-9958-08dd81f6c3aa",
    "imageUrl": "/api/products/images/fitpromeals/products/turkey-breast-16-oz.webp",
    "imageAlt": "Turkey Breast 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Turkey Breast 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Turkey Breast 16 oz from The Prep Kitchen with 33g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Turkey Breast 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 200 calories, 33g protein, 2g carbs, 6g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Turkey Breast 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 200 calories, 33g protein, 2g carbs, 6g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "2439d86e-8ea4-4998-9958-08dd81f6c3aa",
    "pradoVariantId": "0247cd52-8fc6-4d38-f676-08dd81f6c3b1"
  },
  {
    "name": "Tilapia 16 oz",
    "slug": "tilapia-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 18.99,
    "calories": 140,
    "fat": 2,
    "carbs": 1,
    "protein": 29,
    "sourceUrl": "https://theprepkitchen.com/product/tilapia?pid=faeaca59-0f7d-448a-51a6-08dd81f68db2",
    "imageUrl": "/api/products/images/fitpromeals/products/tilapia-16-oz.webp",
    "imageAlt": "Tilapia 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Tilapia 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Tilapia 16 oz from The Prep Kitchen with 29g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Tilapia 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 140 calories, 29g protein, 1g carbs, 2.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Tilapia 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 140 calories, 29g protein, 1g carbs, 2.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "faeaca59-0f7d-448a-51a6-08dd81f68db2",
    "pradoVariantId": "c51abbb9-2163-46a8-1968-08dd81f68dbf"
  },
  {
    "name": "Norwegian Salmon 16 oz",
    "slug": "norwegian-salmon-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 29.99,
    "calories": 280,
    "fat": 18,
    "carbs": 1,
    "protein": 27,
    "sourceUrl": "https://theprepkitchen.com/product/norwegian-salmon?pid=e9eeefeb-4eea-4417-395a-08dd81f5cdf0",
    "imageUrl": "/api/products/images/fitpromeals/products/norwegian-salmon-16-oz.webp",
    "imageAlt": "Norwegian Salmon 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Norwegian Salmon 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Norwegian Salmon 16 oz from The Prep Kitchen with 27g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Norwegian Salmon 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 280 calories, 27g protein, 1g carbs, 18g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Norwegian Salmon 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 280 calories, 27g protein, 1g carbs, 18g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "e9eeefeb-4eea-4417-395a-08dd81f5cdf0",
    "pradoVariantId": "747326ac-5304-46d6-3fae-08dd81f5cdff"
  },
  {
    "name": "Seared Ahi Tuna 16 oz",
    "slug": "seared-ahi-tuna-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 37.99,
    "calories": 140,
    "fat": 1,
    "carbs": 0,
    "protein": 29,
    "sourceUrl": "https://theprepkitchen.com/product/seared-ahi-tuna?pid=3b6c3de0-706c-4978-8020-08dd81f5e6a2",
    "imageUrl": "/api/products/images/fitpromeals/products/seared-ahi-tuna-16-oz.webp",
    "imageAlt": "Seared Ahi Tuna 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Seared Ahi Tuna 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Seared Ahi Tuna 16 oz from The Prep Kitchen with 29g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Seared Ahi Tuna 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 140 calories, 29g protein, 0g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Seared Ahi Tuna 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 140 calories, 29g protein, 0g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "3b6c3de0-706c-4978-8020-08dd81f5e6a2",
    "pradoVariantId": "652a9517-0fa5-4965-a6ce-08dd81f5e6af"
  },
  {
    "name": "Black Bean Puree 16 oz",
    "slug": "black-bean-puree-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 8.99,
    "calories": 120,
    "fat": 1,
    "carbs": 21,
    "protein": 7,
    "sourceUrl": "https://theprepkitchen.com/product/black-bean-puree?pid=01d222c4-9149-4677-4ee6-08dd81f68b0e",
    "imageUrl": "/api/products/images/fitpromeals/products/black-bean-puree-16-oz.webp",
    "imageAlt": "Black Bean Puree 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Black Bean Puree 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Black Bean Puree 16 oz from The Prep Kitchen with 7g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Black Bean Puree 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 120 calories, 7g protein, 21g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Black Bean Puree 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 120 calories, 7g protein, 21g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "01d222c4-9149-4677-4ee6-08dd81f68b0e",
    "pradoVariantId": "09c5baca-f6e7-40a2-302a-08dd81f68b16"
  },
  {
    "name": "Grilled Tofu 16 oz",
    "slug": "grilled-tofu-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 10.99,
    "calories": 200,
    "fat": 14,
    "carbs": 6,
    "protein": 16,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-tofu?pid=7124f6aa-b0be-4784-725c-08dd81f5e976",
    "imageUrl": "/api/products/images/fitpromeals/products/grilled-tofu-16-oz.webp",
    "imageAlt": "Grilled Tofu 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Grilled Tofu 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Grilled Tofu 16 oz from The Prep Kitchen with 16g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Grilled Tofu 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 200 calories, 16g protein, 6g carbs, 14g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Grilled Tofu 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 200 calories, 16g protein, 6g carbs, 14g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "7124f6aa-b0be-4784-725c-08dd81f5e976",
    "pradoVariantId": "213eb6ff-a727-47a1-315e-08dd81f5e97e"
  },
  {
    "name": "Italian Beef Meatballs 16 oz",
    "slug": "italian-beef-meatballs-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 19.99,
    "calories": 390,
    "fat": 35,
    "carbs": 7,
    "protein": 26,
    "sourceUrl": "https://theprepkitchen.com/product/italian-beef-meatballs?pid=7955f727-d7cf-45ca-ec1a-08dd81f6b3e1",
    "imageUrl": "/api/products/images/fitpromeals/products/italian-beef-meatballs-16-oz.webp",
    "imageAlt": "Italian Beef Meatballs 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Italian Beef Meatballs 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Italian Beef Meatballs 16 oz from The Prep Kitchen with 26g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Italian Beef Meatballs 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 390 calories, 26g protein, 7g carbs, 35g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Italian Beef Meatballs 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 390 calories, 26g protein, 7g carbs, 35g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "7955f727-d7cf-45ca-ec1a-08dd81f6b3e1",
    "pradoVariantId": "a43a4dcd-372c-46e6-1ff2-08dd81f6b3ea"
  },
  {
    "name": "Beef Burger Patty - 3 Pack",
    "slug": "beef-burger-patty-3-pack",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 18.99,
    "calories": 390,
    "fat": 24,
    "carbs": 26,
    "protein": 36,
    "sourceUrl": "https://theprepkitchen.com/product/beefburgerpatty3pack?pid=879f0d18-e409-4970-d29c-08dd81f763d2",
    "imageUrl": "/api/products/images/fitpromeals/products/beef-burger-patty-3-pack.webp",
    "imageAlt": "Beef Burger Patty - 3 Pack prepared by The Prep Kitchen",
    "affiliateTitle": "Beef Burger Patty - 3 Pack Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Beef Burger Patty - 3 Pack from The Prep Kitchen with 36g protein. See nutrition details and check current DFW availability through our affiliate l…",
    "description": "Beef Burger Patty - 3 Pack is a ready-to-serve bulk protein or side from The Prep Kitchen with 390 calories, 36g protein, 26g carbs, 24g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Beef Burger Patty - 3 Pack is a ready-to-serve bulk protein or side from The Prep Kitchen with 390 calories, 36g protein, 26g carbs, 24g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "879f0d18-e409-4970-d29c-08dd81f763d2",
    "pradoVariantId": "5e57e336-249f-4c8c-f3fe-08dd81f763db"
  },
  {
    "name": "Cilantro Lime Jasmine Rice 16 oz",
    "slug": "cilantro-lime-jasmine-rice-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 9.49,
    "calories": 190,
    "fat": 0,
    "carbs": 42,
    "protein": 4,
    "sourceUrl": "https://theprepkitchen.com/product/cilantro-lime-jasmine-rice?pid=f136e049-5046-4f02-c25e-08dd81f5d6af",
    "imageUrl": "/api/products/images/fitpromeals/products/cilantro-lime-jasmine-rice-16-oz.webp",
    "imageAlt": "Cilantro Lime Jasmine Rice 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Cilantro Lime Jasmine Rice 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Cilantro Lime Jasmine Rice 16 oz from The Prep Kitchen with 4g protein. See nutrition details and check current DFW availability through our affili…",
    "description": "Cilantro Lime Jasmine Rice 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 190 calories, 4g protein, 42g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Cilantro Lime Jasmine Rice 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 190 calories, 4g protein, 42g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "f136e049-5046-4f02-c25e-08dd81f5d6af",
    "pradoVariantId": "816bcdf7-3ca7-438a-ae7e-08dd81f5d6b7"
  },
  {
    "name": "Brown Basmati Rice 16 oz",
    "slug": "brown-basmati-rice-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": "NEW",
    "price": 8.99,
    "calories": 160,
    "fat": 1,
    "carbs": 35,
    "protein": 3,
    "sourceUrl": "https://theprepkitchen.com/product/brown-basmati-rice?pid=1a9f19d2-aa27-49e0-4e95-08ddf087a179",
    "imageUrl": "/api/products/images/fitpromeals/products/brown-basmati-rice-16-oz.webp",
    "imageAlt": "Brown Basmati Rice 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Brown Basmati Rice 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Brown Basmati Rice 16 oz from The Prep Kitchen with 3g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Brown Basmati Rice 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 160 calories, 3g protein, 35g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Brown Basmati Rice 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 160 calories, 3g protein, 35g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "1a9f19d2-aa27-49e0-4e95-08ddf087a179",
    "pradoVariantId": "b8bfde0a-5ed4-4838-c313-08ddf087a1b6"
  },
  {
    "name": "Red Skin Mashed Potatoes 16 oz",
    "slug": "red-skin-mashed-potatoes-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 11.49,
    "calories": 100,
    "fat": 2,
    "carbs": 18,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/red-skin-mashed-potatoes?pid=0926eba6-45f1-4c0f-0242-08dd81f689fb",
    "imageUrl": "/api/products/images/fitpromeals/products/red-skin-mashed-potatoes-16-oz.webp",
    "imageAlt": "Red Skin Mashed Potatoes 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Red Skin Mashed Potatoes 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Red Skin Mashed Potatoes 16 oz from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliat…",
    "description": "Red Skin Mashed Potatoes 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 100 calories, 2g protein, 18g carbs, 2.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Red Skin Mashed Potatoes 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 100 calories, 2g protein, 18g carbs, 2.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "0926eba6-45f1-4c0f-0242-08dd81f689fb",
    "pradoVariantId": "573d7907-d7a5-4c48-7950-08dd81f68a02"
  },
  {
    "name": "Roasted Red Potatoes 16 oz",
    "slug": "roasted-red-potatoes-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 11.99,
    "calories": 150,
    "fat": 4,
    "carbs": 26,
    "protein": 3,
    "sourceUrl": "https://theprepkitchen.com/product/roasted-red-potatoes?pid=4d6d9bc0-8554-4855-a4dc-08dd81f5da3c",
    "imageUrl": "/api/products/images/fitpromeals/products/roasted-red-potatoes-16-oz.webp",
    "imageAlt": "Roasted Red Potatoes 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Roasted Red Potatoes 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Roasted Red Potatoes 16 oz from The Prep Kitchen with 3g protein. See nutrition details and check current DFW availability through our affiliate li…",
    "description": "Roasted Red Potatoes 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 150 calories, 3g protein, 26g carbs, 4.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Roasted Red Potatoes 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 150 calories, 3g protein, 26g carbs, 4.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "4d6d9bc0-8554-4855-a4dc-08dd81f5da3c",
    "pradoVariantId": "c4ebddea-e03d-495d-2fb2-08dd81f5da45"
  },
  {
    "name": "Roasted Sweet Potatoes 16 oz",
    "slug": "roasted-sweet-potatoes-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 11.99,
    "calories": 180,
    "fat": 5,
    "carbs": 32,
    "protein": 3,
    "sourceUrl": "https://theprepkitchen.com/product/roasted-sweet-potatoes?pid=9f369e75-3c13-4f82-0db0-08dd81f5db6d",
    "imageUrl": "/api/products/images/fitpromeals/products/roasted-sweet-potatoes-16-oz.webp",
    "imageAlt": "Roasted Sweet Potatoes 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Roasted Sweet Potatoes 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Roasted Sweet Potatoes 16 oz from The Prep Kitchen with 3g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Roasted Sweet Potatoes 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 180 calories, 3g protein, 32g carbs, 5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Roasted Sweet Potatoes 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 180 calories, 3g protein, 32g carbs, 5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "9f369e75-3c13-4f82-0db0-08dd81f5db6d",
    "pradoVariantId": "9cf2d597-56f6-4822-ad6c-08dd81f5db75"
  },
  {
    "name": "Sweet Potato Mash 16 oz",
    "slug": "sweet-potato-mash-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 11.49,
    "calories": 120,
    "fat": 2,
    "carbs": 23,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/sweet-potato-mash?pid=baa7db1e-f3ea-49c9-6e46-08dd81f688e6",
    "imageUrl": "/api/products/images/fitpromeals/products/sweet-potato-mash-16-oz.webp",
    "imageAlt": "Sweet Potato Mash 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Sweet Potato Mash 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Sweet Potato Mash 16 oz from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Sweet Potato Mash 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 120 calories, 2g protein, 23g carbs, 2.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Sweet Potato Mash 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 120 calories, 2g protein, 23g carbs, 2.5g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "baa7db1e-f3ea-49c9-6e46-08dd81f688e6",
    "pradoVariantId": "1f1604f3-8aae-4bbf-c100-08dd81f688ed"
  },
  {
    "name": "High Protein Mac & Cheese 16 oz",
    "slug": "high-protein-mac-and-cheese-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 11.99,
    "calories": 240,
    "fat": 12,
    "carbs": 22,
    "protein": 14,
    "sourceUrl": "https://theprepkitchen.com/product/high-protein-mac-cheese?pid=0acbe28b-2e28-489f-95ce-08dd81f74943",
    "imageUrl": "/api/products/images/fitpromeals/products/high-protein-mac-and-cheese-16-oz.webp",
    "imageAlt": "High Protein Mac & Cheese 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "High Protein Mac & Cheese 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review High Protein Mac & Cheese 16 oz from The Prep Kitchen with 14g protein. See nutrition details and check current DFW availability through our affili…",
    "description": "High Protein Mac & Cheese 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 240 calories, 14g protein, 22g carbs, 12g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "High Protein Mac & Cheese 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 240 calories, 14g protein, 22g carbs, 12g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "0acbe28b-2e28-489f-95ce-08dd81f74943",
    "pradoVariantId": "8026e564-6901-48d0-87f4-08dd81f74958"
  },
  {
    "name": "Really Good GF Pasta 16 oz",
    "slug": "really-good-gf-pasta-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 9.99,
    "calories": 240,
    "fat": 7,
    "carbs": 39,
    "protein": 13,
    "sourceUrl": "https://theprepkitchen.com/product/really-good-gf-pasta?pid=01a90b22-3270-4001-51dc-08dd81f73e7f",
    "imageUrl": "/api/products/images/fitpromeals/products/really-good-gf-pasta-16-oz.webp",
    "imageAlt": "Really Good GF Pasta 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Really Good GF Pasta 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Really Good GF Pasta 16 oz from The Prep Kitchen with 13g protein. See nutrition details and check current DFW availability through our affiliate l…",
    "description": "Really Good GF Pasta 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 240 calories, 13g protein, 39g carbs, 7g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Really Good GF Pasta 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 240 calories, 13g protein, 39g carbs, 7g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "01a90b22-3270-4001-51dc-08dd81f73e7f",
    "pradoVariantId": "414e9b29-7c21-4c15-496e-08dd81f73e87"
  },
  {
    "name": "Homemade Granola Bars 16 oz",
    "slug": "homemade-granola-bars-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 13.99,
    "calories": 250,
    "fat": 14,
    "carbs": 27,
    "protein": 5,
    "sourceUrl": "https://theprepkitchen.com/product/homemade-granola-bars?pid=a4622041-d3ac-40c9-2698-08dd81f69b42",
    "imageUrl": "/api/products/images/fitpromeals/products/homemade-granola-bars-16-oz.webp",
    "imageAlt": "Homemade Granola Bars 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Homemade Granola Bars 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Homemade Granola Bars 16 oz from The Prep Kitchen with 5g protein. See nutrition details and check current DFW availability through our affiliate l…",
    "description": "Homemade Granola Bars 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 250 calories, 5g protein, 27g carbs, 14g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Homemade Granola Bars 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 250 calories, 5g protein, 27g carbs, 14g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "a4622041-d3ac-40c9-2698-08dd81f69b42",
    "pradoVariantId": "50538975-ea30-46c1-a25a-08dd81f69b4a"
  },
  {
    "name": "Sautéed Spinach 16 oz",
    "slug": "saut-ed-spinach-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 14.99,
    "calories": 40,
    "fat": 1,
    "carbs": 6,
    "protein": 4,
    "sourceUrl": "https://theprepkitchen.com/product/sauteed-spinach?pid=7ac04661-866e-4308-573a-08dd81f761b7",
    "imageUrl": "/api/products/images/fitpromeals/products/saut-ed-spinach-16-oz.webp",
    "imageAlt": "Sautéed Spinach 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Sautéed Spinach 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Sautéed Spinach 16 oz from The Prep Kitchen with 4g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Sautéed Spinach 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 40 calories, 4g protein, 6g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Sautéed Spinach 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 40 calories, 4g protein, 6g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "7ac04661-866e-4308-573a-08dd81f761b7",
    "pradoVariantId": "27dfa22f-b365-42b7-c190-08dd81f761bf"
  },
  {
    "name": "Roasted Broccoli 16 oz",
    "slug": "roasted-broccoli-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 12.99,
    "calories": 60,
    "fat": 2,
    "carbs": 10,
    "protein": 4,
    "sourceUrl": "https://theprepkitchen.com/product/roasted-broccoli?pid=a654d540-814c-490f-33e4-08dd81f77ee6",
    "imageUrl": "/api/products/images/fitpromeals/products/roasted-broccoli-16-oz.webp",
    "imageAlt": "Roasted Broccoli 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Roasted Broccoli 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Roasted Broccoli 16 oz from The Prep Kitchen with 4g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Roasted Broccoli 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 60 calories, 4g protein, 10g carbs, 2g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Roasted Broccoli 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 60 calories, 4g protein, 10g carbs, 2g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "a654d540-814c-490f-33e4-08dd81f77ee6",
    "pradoVariantId": "ac075dfe-e591-4b12-8fb2-08dd81f77eee"
  },
  {
    "name": "Roasted Brussel Sprouts 16 oz",
    "slug": "roasted-brussel-sprouts-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 13.99,
    "calories": 150,
    "fat": 10,
    "carbs": 14,
    "protein": 5,
    "sourceUrl": "https://theprepkitchen.com/product/roasted-brussel-sprouts?pid=59bdc2cd-52a8-4c8f-2624-08dd81f5e018",
    "imageUrl": "/api/products/images/fitpromeals/products/roasted-brussel-sprouts-16-oz.webp",
    "imageAlt": "Roasted Brussel Sprouts 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Roasted Brussel Sprouts 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Roasted Brussel Sprouts 16 oz from The Prep Kitchen with 5g protein. See nutrition details and check current DFW availability through our affiliate…",
    "description": "Roasted Brussel Sprouts 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 150 calories, 5g protein, 14g carbs, 10g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Roasted Brussel Sprouts 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 150 calories, 5g protein, 14g carbs, 10g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "59bdc2cd-52a8-4c8f-2624-08dd81f5e018",
    "pradoVariantId": "b365248c-1eb4-470c-a886-08dd81f5e01f"
  },
  {
    "name": "Zucchini 16 oz",
    "slug": "zucchini-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 10.99,
    "calories": 90,
    "fat": 8,
    "carbs": 6,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/zucchini?pid=6cc61a76-6e01-4725-5c3c-08dd81f5e56f",
    "imageUrl": "/api/products/images/fitpromeals/products/zucchini-16-oz.webp",
    "imageAlt": "Zucchini 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Zucchini 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Zucchini 16 oz from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Zucchini 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 90 calories, 2g protein, 6g carbs, 8g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Zucchini 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 90 calories, 2g protein, 6g carbs, 8g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "6cc61a76-6e01-4725-5c3c-08dd81f5e56f",
    "pradoVariantId": "5851b1ce-206a-4c4f-1804-08dd81f5e578"
  },
  {
    "name": "Green Beans 16 oz",
    "slug": "green-beans-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 11.99,
    "calories": 35,
    "fat": 0,
    "carbs": 8,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/green-beans?pid=3f5d9f1d-1f99-4624-3936-08dd81f5ddc3",
    "imageUrl": "/api/products/images/fitpromeals/products/green-beans-16-oz.webp",
    "imageAlt": "Green Beans 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Green Beans 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Green Beans 16 oz from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Green Beans 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 35 calories, 2g protein, 8g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Green Beans 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 35 calories, 2g protein, 8g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "3f5d9f1d-1f99-4624-3936-08dd81f5ddc3",
    "pradoVariantId": "61de8279-6107-43fb-2088-08dd81f5ddcb"
  },
  {
    "name": "Grilled Asparagus 16 oz",
    "slug": "grilled-asparagus-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 18.99,
    "calories": 35,
    "fat": 1,
    "carbs": 6,
    "protein": 3,
    "sourceUrl": "https://theprepkitchen.com/product/grilled-asparagus?pid=c3037484-c966-42ba-fb44-08dd81f78099",
    "imageUrl": "/api/products/images/fitpromeals/products/grilled-asparagus-16-oz.webp",
    "imageAlt": "Grilled Asparagus 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Grilled Asparagus 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Grilled Asparagus 16 oz from The Prep Kitchen with 3g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Grilled Asparagus 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 35 calories, 3g protein, 6g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Grilled Asparagus 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 35 calories, 3g protein, 6g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "c3037484-c966-42ba-fb44-08dd81f78099",
    "pradoVariantId": "9ca33fa2-54dc-4839-6edc-08dd81f780ac"
  },
  {
    "name": "Crimini Mushrooms 16 oz",
    "slug": "crimini-mushrooms-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 13.99,
    "calories": 120,
    "fat": 10,
    "carbs": 7,
    "protein": 4,
    "sourceUrl": "https://theprepkitchen.com/product/crimini-mushrooms?pid=67706474-4cf9-423e-6362-08dd81f6444c",
    "imageUrl": "/api/products/images/fitpromeals/products/crimini-mushrooms-16-oz.webp",
    "imageAlt": "Crimini Mushrooms 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Crimini Mushrooms 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Crimini Mushrooms 16 oz from The Prep Kitchen with 4g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Crimini Mushrooms 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 120 calories, 4g protein, 7g carbs, 10g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Crimini Mushrooms 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 120 calories, 4g protein, 7g carbs, 10g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "67706474-4cf9-423e-6362-08dd81f6444c",
    "pradoVariantId": "22a1a747-bf5b-4c4c-19c2-08dd81f64454"
  },
  {
    "name": "Cauliflower Mash 16 oz",
    "slug": "cauliflower-mash-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 13.99,
    "calories": 110,
    "fat": 10,
    "carbs": 7,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/cauliflower-mash?pid=aaa4ffae-ce28-459c-3742-08dd81f75fea",
    "imageUrl": "/api/products/images/fitpromeals/products/cauliflower-mash-16-oz.webp",
    "imageAlt": "Cauliflower Mash 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Cauliflower Mash 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Cauliflower Mash 16 oz from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Cauliflower Mash 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 110 calories, 2g protein, 7g carbs, 10g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Cauliflower Mash 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 110 calories, 2g protein, 7g carbs, 10g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "aaa4ffae-ce28-459c-3742-08dd81f75fea",
    "pradoVariantId": "ebece1bf-cd73-48c3-99c8-08dd81f75ff2"
  },
  {
    "name": "Roasted Carrots 16 oz",
    "slug": "roasted-carrots-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 16.99,
    "calories": 90,
    "fat": 3,
    "carbs": 15,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/roasted-carrots?pid=a1dfb13a-8d5b-4f27-ac3c-08dd81f64dc0",
    "imageUrl": "/api/products/images/fitpromeals/products/roasted-carrots-16-oz.webp",
    "imageAlt": "Roasted Carrots 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Roasted Carrots 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Roasted Carrots 16 oz from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Roasted Carrots 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 90 calories, 2g protein, 15g carbs, 3g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Roasted Carrots 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 90 calories, 2g protein, 15g carbs, 3g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "a1dfb13a-8d5b-4f27-ac3c-08dd81f64dc0",
    "pradoVariantId": "adf412cf-0ee1-4378-0982-08dd81f64dc8"
  },
  {
    "name": "Roasted Corn 16 oz",
    "slug": "roasted-corn-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 9.99,
    "calories": 100,
    "fat": 1,
    "carbs": 23,
    "protein": 3,
    "sourceUrl": "https://theprepkitchen.com/product/roasted-corn?pid=5cad4c95-8edd-465a-0938-08dd81f64589",
    "imageUrl": "/api/products/images/fitpromeals/products/roasted-corn-16-oz.webp",
    "imageAlt": "Roasted Corn 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Roasted Corn 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Roasted Corn 16 oz from The Prep Kitchen with 3g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Roasted Corn 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 100 calories, 3g protein, 23g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Roasted Corn 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 100 calories, 3g protein, 23g carbs, 1g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "5cad4c95-8edd-465a-0938-08dd81f64589",
    "pradoVariantId": "0512b931-982e-4615-ab48-08dd81f64590"
  },
  {
    "name": "Zucchini Noodles 12 oz",
    "slug": "zucchini-noodles-12-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 7.99,
    "calories": 20,
    "fat": 0,
    "carbs": 3,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/zucchini-noodles?pid=939e2e23-5358-4cc4-9bd0-08dd81f642fc",
    "imageUrl": "/api/products/images/fitpromeals/products/zucchini-noodles-12-oz.webp",
    "imageAlt": "Zucchini Noodles 12 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Zucchini Noodles 12 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Zucchini Noodles 12 oz from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Zucchini Noodles 12 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 20 calories, 1g protein, 3g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Zucchini Noodles 12 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 20 calories, 1g protein, 3g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "939e2e23-5358-4cc4-9bd0-08dd81f642fc",
    "pradoVariantId": "aa8e9c1f-ab71-4e78-69fa-08dd81f64304"
  },
  {
    "name": "Fajita Mix 16 oz",
    "slug": "fajita-mix-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 8.99,
    "calories": 70,
    "fat": 3,
    "carbs": 11,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/fajita-mix?pid=13acd230-db99-424b-472e-08dd81f64c12",
    "imageUrl": "/api/products/images/fitpromeals/products/fajita-mix-16-oz.webp",
    "imageAlt": "Fajita Mix 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Fajita Mix 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Fajita Mix 16 oz from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Fajita Mix 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 70 calories, 2g protein, 11g carbs, 3g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Fajita Mix 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 70 calories, 2g protein, 11g carbs, 3g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "13acd230-db99-424b-472e-08dd81f64c12",
    "pradoVariantId": "e1c15a7b-0445-48c0-3f6a-08dd81f64c1a"
  },
  {
    "name": "Fruit Medley 16 oz",
    "slug": "fruit-medley-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 8.99,
    "calories": 50,
    "fat": 0,
    "carbs": 13,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/fruit-medley?pid=cf40a8e8-7452-4532-a7c2-08dd81f64ac4",
    "imageUrl": "/api/products/images/fitpromeals/products/fruit-medley-16-oz.webp",
    "imageAlt": "Fruit Medley 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Fruit Medley 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Fruit Medley 16 oz from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Fruit Medley 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 50 calories, 1g protein, 13g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Fruit Medley 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 50 calories, 1g protein, 13g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "cf40a8e8-7452-4532-a7c2-08dd81f64ac4",
    "pradoVariantId": "c8853980-f079-48cd-d99c-08dd81f64acc"
  },
  {
    "name": "Cantaloupe 16 oz",
    "slug": "cantaloupe-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 8.99,
    "calories": 40,
    "fat": 0,
    "carbs": 9,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/cantaloupe?pid=c8dea281-4632-43d0-107a-08dd81f6515c",
    "imageUrl": "/api/products/images/fitpromeals/products/cantaloupe-16-oz.webp",
    "imageAlt": "Cantaloupe 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Cantaloupe 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Cantaloupe 16 oz from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Cantaloupe 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 40 calories, 1g protein, 9g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Cantaloupe 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 40 calories, 1g protein, 9g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "c8dea281-4632-43d0-107a-08dd81f6515c",
    "pradoVariantId": "6b6e641f-0e41-4d45-b418-08dd81f65165"
  },
  {
    "name": "Pineapple 16 oz",
    "slug": "pineapple-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 8.99,
    "calories": 60,
    "fat": 0,
    "carbs": 15,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/pineapple?pid=95235e69-cf29-4de3-68e6-08dd81f64ee0",
    "imageUrl": "/api/products/images/fitpromeals/products/pineapple-16-oz.webp",
    "imageAlt": "Pineapple 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Pineapple 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Pineapple 16 oz from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Pineapple 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 60 calories, 1g protein, 15g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Pineapple 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 60 calories, 1g protein, 15g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "95235e69-cf29-4de3-68e6-08dd81f64ee0",
    "pradoVariantId": "10608644-23d8-47d2-2d66-08dd81f64eec"
  },
  {
    "name": "Grapes 16 oz",
    "slug": "grapes-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 8.99,
    "calories": 80,
    "fat": 0,
    "carbs": 21,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/grapes?pid=94486ca7-5c1d-4c49-d6fe-08dd81f653dc",
    "imageUrl": "/api/products/images/fitpromeals/products/grapes-16-oz.webp",
    "imageAlt": "Grapes 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Grapes 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Grapes 16 oz from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Grapes 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 80 calories, 1g protein, 21g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Grapes 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 80 calories, 1g protein, 21g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "94486ca7-5c1d-4c49-d6fe-08dd81f653dc",
    "pradoVariantId": "99905131-74af-4adc-3110-08dd81f653e9"
  },
  {
    "name": "Strawberry 16 oz",
    "slug": "strawberry-16-oz",
    "category": "Bulk Protein & Sides",
    "badge": null,
    "price": 11.99,
    "calories": 35,
    "fat": 0,
    "carbs": 9,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/strawberry?pid=37fae7d8-0be7-4ec2-5d30-08dd81f65299",
    "imageUrl": "/api/products/images/fitpromeals/products/strawberry-16-oz.webp",
    "imageAlt": "Strawberry 16 oz prepared by The Prep Kitchen",
    "affiliateTitle": "Strawberry 16 oz Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Strawberry 16 oz from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Strawberry 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 35 calories, 1g protein, 9g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Strawberry 16 oz is a ready-to-serve bulk protein or side from The Prep Kitchen with 35 calories, 1g protein, 9g carbs, 0g fat per listed serving. Use it to assemble flexible meals at home while saving prep time.",
    "pradoProductId": "37fae7d8-0be7-4ec2-5d30-08dd81f65299",
    "pradoVariantId": "04ae101f-49e2-41da-aab8-08dd81f652a0"
  },
  {
    "name": "Build Your Meal",
    "slug": "build-your-meal",
    "category": "Build-Your-Meal",
    "badge": null,
    "price": 12.99,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/build-your-meal?pid=2236a15b-d81b-4682-6860-08dd9649c7b9",
    "imageUrl": "/api/products/images/fitpromeals/products/build-your-meal.webp",
    "imageAlt": "Build Your Meal prepared by The Prep Kitchen",
    "affiliateTitle": "Build Your Meal Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Build Your Meal from The Prep Kitchen. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Build Your Meal is available from The Prep Kitchen. Review the merchant page for current ingredients, availability, serving details, and ordering options. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Build Your Meal is available from The Prep Kitchen. Review the merchant page for current ingredients, availability, serving details, and ordering options.",
    "pradoProductId": null,
    "pradoVariantId": null
  },
  {
    "name": "Breakfast Build Your Meal",
    "slug": "breakfast-build-your-meal",
    "category": "Build-Your-Meal",
    "badge": "NEW",
    "price": 12.99,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/breakfast-build-your-meal?pid=b6842f9b-945f-4425-938f-08de3c39bb85",
    "imageUrl": "/api/products/images/fitpromeals/products/breakfast-build-your-meal.webp",
    "imageAlt": "Breakfast Build Your Meal prepared by The Prep Kitchen",
    "affiliateTitle": "Breakfast Build Your Meal Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Breakfast Build Your Meal from The Prep Kitchen. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Breakfast Build Your Meal is available from The Prep Kitchen. Review the merchant page for current ingredients, availability, serving details, and ordering options. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Breakfast Build Your Meal is available from The Prep Kitchen. Review the merchant page for current ingredients, availability, serving details, and ordering options.",
    "pradoProductId": null,
    "pradoVariantId": null
  },
  {
    "name": "Protein Brownie - Sweet Addison's",
    "slug": "protein-brownie-sweet-addison-s",
    "category": "Desserts & Snacks",
    "badge": "BEST SELLER",
    "price": 5.99,
    "calories": 380,
    "fat": 27,
    "carbs": 20,
    "protein": 15,
    "sourceUrl": "https://theprepkitchen.com/product/protein-brownie-sweet-addisons?pid=f37c374b-b1ca-4e08-c3dc-08de7df5cd84",
    "imageUrl": "/api/products/images/fitpromeals/products/protein-brownie-sweet-addison-s.webp",
    "imageAlt": "Protein Brownie - Sweet Addison's prepared by The Prep Kitchen",
    "affiliateTitle": "Protein Brownie - Sweet Addison's Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Protein Brownie - Sweet Addison's from The Prep Kitchen with 15g protein. See nutrition details and check current DFW availability through our affi…",
    "description": "Protein Brownie - Sweet Addison's is a convenient prepared snack or dessert from The Prep Kitchen with 380 calories, 15g protein, 20g carbs, 27g fat. It is an easy add-on for customers who want something satisfying between meals. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Protein Brownie - Sweet Addison's is a convenient prepared snack or dessert from The Prep Kitchen with 380 calories, 15g protein, 20g carbs, 27g fat. It is an easy add-on for customers who want something satisfying between meals.",
    "pradoProductId": "f37c374b-b1ca-4e08-c3dc-08de7df5cd84",
    "pradoVariantId": "a9f1695e-d7a5-4f10-c1cf-08de7df5ce44"
  },
  {
    "name": "The Protein Cookie - Chocolate Chip Sweet Addison's",
    "slug": "the-protein-cookie-chocolate-chip-sweet-addison-s",
    "category": "Desserts & Snacks",
    "badge": "BEST SELLER",
    "price": 5.99,
    "calories": 350,
    "fat": 25,
    "carbs": 22,
    "protein": 17,
    "sourceUrl": "https://theprepkitchen.com/product/theproteincookie-chocolatechip?pid=510b9726-b728-41da-658a-08ddc6543ac1",
    "imageUrl": "/api/products/images/fitpromeals/products/the-protein-cookie-chocolate-chip-sweet-addison-s.webp",
    "imageAlt": "The Protein Cookie - Chocolate Chip Sweet Addison's prepared by The Prep Kitchen",
    "affiliateTitle": "The Protein Cookie - Chocolate Chip Sweet Addison's Meal in DFW…",
    "affiliateMeta": "Review The Protein Cookie - Chocolate Chip Sweet Addison's from The Prep Kitchen with 17g protein. See nutrition details and check current DFW availabilit…",
    "description": "The Protein Cookie - Chocolate Chip Sweet Addison's is a convenient prepared snack or dessert from The Prep Kitchen with 350 calories, 17g protein, 22g carbs, 25g fat. It is an easy add-on for customers who want something satisfying between meals. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "The Protein Cookie - Chocolate Chip Sweet Addison's is a convenient prepared snack or dessert from The Prep Kitchen with 350 calories, 17g protein, 22g carbs, 25g fat. It is an easy add-on for customers who want something satisfying between meals.",
    "pradoProductId": "510b9726-b728-41da-658a-08ddc6543ac1",
    "pradoVariantId": "4fac0ed3-2e03-4f0b-ac62-08ddc6543bba"
  },
  {
    "name": "Brookie - Sweet Addison's",
    "slug": "brookie-sweet-addison-s",
    "category": "Desserts & Snacks",
    "badge": "BEST SELLER",
    "price": 5.99,
    "calories": 380,
    "fat": 27,
    "carbs": 21,
    "protein": 8,
    "sourceUrl": "https://theprepkitchen.com/product/brookiesweetaddisons?pid=dd85c5d7-df64-4da6-1ca2-08dd81f7d31d",
    "imageUrl": "/api/products/images/fitpromeals/products/brookie-sweet-addison-s.webp",
    "imageAlt": "Brookie - Sweet Addison's prepared by The Prep Kitchen",
    "affiliateTitle": "Brookie - Sweet Addison's Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Brookie - Sweet Addison's from The Prep Kitchen with 8g protein. See nutrition details and check current DFW availability through our affiliate lin…",
    "description": "Brookie - Sweet Addison's is a convenient prepared snack or dessert from The Prep Kitchen with 380 calories, 8g protein, 21g carbs, 27g fat. It is an easy add-on for customers who want something satisfying between meals. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Brookie - Sweet Addison's is a convenient prepared snack or dessert from The Prep Kitchen with 380 calories, 8g protein, 21g carbs, 27g fat. It is an easy add-on for customers who want something satisfying between meals.",
    "pradoProductId": "dd85c5d7-df64-4da6-1ca2-08dd81f7d31d",
    "pradoVariantId": "9f794ed0-e078-4700-40f8-08dd81f7d325"
  },
  {
    "name": "BUFFALO SAUCE",
    "slug": "buffalo-sauce",
    "category": "Sauces",
    "badge": null,
    "price": 6.99,
    "calories": 50,
    "fat": 6,
    "carbs": 2,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/buffalo-sauce?pid=7ca0bcff-07f9-4815-0c9e-08dd81f6cb71",
    "imageUrl": "/api/products/images/fitpromeals/products/buffalo-sauce.webp",
    "imageAlt": "BUFFALO SAUCE prepared by The Prep Kitchen",
    "affiliateTitle": "BUFFALO SAUCE Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review BUFFALO SAUCE from The Prep Kitchen with 0g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "BUFFALO SAUCE is a prepared sauce from The Prep Kitchen with 50 calories, 0g protein, 2g carbs, 6g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "BUFFALO SAUCE is a prepared sauce from The Prep Kitchen with 50 calories, 0g protein, 2g carbs, 6g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "7ca0bcff-07f9-4815-0c9e-08dd81f6cb71",
    "pradoVariantId": "2b6975c1-6349-476a-673c-08dd81f6cb7d"
  },
  {
    "name": "GREEK YOGURT RANCH",
    "slug": "greek-yogurt-ranch",
    "category": "Sauces",
    "badge": null,
    "price": 5.99,
    "calories": 40,
    "fat": 3,
    "carbs": 2,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/greek-yogurt-ranch?pid=e49ccd10-b3a7-49d4-db0e-08dd81f686d6",
    "imageUrl": "/api/products/images/fitpromeals/products/greek-yogurt-ranch.webp",
    "imageAlt": "GREEK YOGURT RANCH prepared by The Prep Kitchen",
    "affiliateTitle": "GREEK YOGURT RANCH Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review GREEK YOGURT RANCH from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "GREEK YOGURT RANCH is a prepared sauce from The Prep Kitchen with 40 calories, 2g protein, 2g carbs, 3g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "GREEK YOGURT RANCH is a prepared sauce from The Prep Kitchen with 40 calories, 2g protein, 2g carbs, 3g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "e49ccd10-b3a7-49d4-db0e-08dd81f686d6",
    "pradoVariantId": "206e87d3-e828-427f-e910-08dd81f686df"
  },
  {
    "name": "MARINARA",
    "slug": "marinara",
    "category": "Sauces",
    "badge": null,
    "price": 7.99,
    "calories": 10,
    "fat": 0,
    "carbs": 8,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/marinara?pid=2bc94715-73ca-4714-8598-08dd81f66ae6",
    "imageUrl": "/api/products/images/fitpromeals/products/marinara.webp",
    "imageAlt": "MARINARA prepared by The Prep Kitchen",
    "affiliateTitle": "MARINARA Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review MARINARA from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "MARINARA is a prepared sauce from The Prep Kitchen with 10 calories, 2g protein, 8g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "MARINARA is a prepared sauce from The Prep Kitchen with 10 calories, 2g protein, 8g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "2bc94715-73ca-4714-8598-08dd81f66ae6",
    "pradoVariantId": "958d685b-a566-4750-fc8c-08dd81f66b07"
  },
  {
    "name": "PESTO",
    "slug": "pesto",
    "category": "Sauces",
    "badge": null,
    "price": 8.99,
    "calories": 110,
    "fat": 14,
    "carbs": 1,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/pesto?pid=8782f5f3-b32d-4795-767c-08dd81f67052",
    "imageUrl": "/api/products/images/fitpromeals/products/pesto.webp",
    "imageAlt": "PESTO prepared by The Prep Kitchen",
    "affiliateTitle": "PESTO Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PESTO from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "PESTO is a prepared sauce from The Prep Kitchen with 110 calories, 1g protein, 1g carbs, 14g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PESTO is a prepared sauce from The Prep Kitchen with 110 calories, 1g protein, 1g carbs, 14g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "8782f5f3-b32d-4795-767c-08dd81f67052",
    "pradoVariantId": "cfb9927c-3fd9-494f-1260-08dd81f6705a"
  },
  {
    "name": "PICO DE GALLO",
    "slug": "pico-de-gallo",
    "category": "Sauces",
    "badge": null,
    "price": 4.99,
    "calories": 5,
    "fat": 0,
    "carbs": 2,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/pico-de-gallo?pid=3e1a2877-aad7-488b-08c2-08dd81f66f2b",
    "imageUrl": "/api/products/images/fitpromeals/products/pico-de-gallo.webp",
    "imageAlt": "PICO DE GALLO prepared by The Prep Kitchen",
    "affiliateTitle": "PICO DE GALLO Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PICO DE GALLO from The Prep Kitchen with 0.5g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "PICO DE GALLO is a prepared sauce from The Prep Kitchen with 5 calories, 0.5g protein, 2g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PICO DE GALLO is a prepared sauce from The Prep Kitchen with 5 calories, 0.5g protein, 2g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "3e1a2877-aad7-488b-08c2-08dd81f66f2b",
    "pradoVariantId": "f903e83f-598f-4b11-d5a6-08dd81f66f33"
  },
  {
    "name": "PK STEAK SAUCE",
    "slug": "pk-steak-sauce",
    "category": "Sauces",
    "badge": null,
    "price": 5.99,
    "calories": 60,
    "fat": 0,
    "carbs": 13,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/pk-steak-sauce?pid=4b0f05af-34ae-4b76-d142-08dd81f6be06",
    "imageUrl": "/api/products/images/fitpromeals/products/pk-steak-sauce.webp",
    "imageAlt": "PK STEAK SAUCE prepared by The Prep Kitchen",
    "affiliateTitle": "PK STEAK SAUCE Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review PK STEAK SAUCE from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "PK STEAK SAUCE is a prepared sauce from The Prep Kitchen with 60 calories, 1g protein, 13g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "PK STEAK SAUCE is a prepared sauce from The Prep Kitchen with 60 calories, 1g protein, 13g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "4b0f05af-34ae-4b76-d142-08dd81f6be06",
    "pradoVariantId": "1cc33d98-b8c3-4dd2-810c-08dd81f6be19"
  },
  {
    "name": "SALSA ROJA",
    "slug": "salsa-roja",
    "category": "Sauces",
    "badge": null,
    "price": 4.99,
    "calories": 5,
    "fat": 0,
    "carbs": 2,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/salsa-roja?pid=f7ccc347-91f9-4c31-7616-08dd81f66e06",
    "imageUrl": "/api/products/images/fitpromeals/products/salsa-roja.webp",
    "imageAlt": "SALSA ROJA prepared by The Prep Kitchen",
    "affiliateTitle": "SALSA ROJA Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review SALSA ROJA from The Prep Kitchen with 0g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "SALSA ROJA is a prepared sauce from The Prep Kitchen with 5 calories, 0g protein, 2g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "SALSA ROJA is a prepared sauce from The Prep Kitchen with 5 calories, 0g protein, 2g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "f7ccc347-91f9-4c31-7616-08dd81f66e06",
    "pradoVariantId": "5e527678-d387-49f5-72bc-08dd81f66e13"
  },
  {
    "name": "SALSA VERDE",
    "slug": "salsa-verde",
    "category": "Sauces",
    "badge": null,
    "price": 4.99,
    "calories": 15,
    "fat": 0,
    "carbs": 3,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/salsa-verde?pid=a8defccc-a6a1-468f-5c08-08dd81f66d0c",
    "imageUrl": "/api/products/images/fitpromeals/products/salsa-verde.webp",
    "imageAlt": "SALSA VERDE prepared by The Prep Kitchen",
    "affiliateTitle": "SALSA VERDE Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review SALSA VERDE from The Prep Kitchen with 0.5g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "SALSA VERDE is a prepared sauce from The Prep Kitchen with 15 calories, 0.5g protein, 3g carbs, 0.5g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "SALSA VERDE is a prepared sauce from The Prep Kitchen with 15 calories, 0.5g protein, 3g carbs, 0.5g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "a8defccc-a6a1-468f-5c08-08dd81f66d0c",
    "pradoVariantId": "b38ef3ac-3523-4c44-cc54-08dd81f66d18"
  },
  {
    "name": "SUGAR FREE SYRUP",
    "slug": "sugar-free-syrup",
    "category": "Sauces",
    "badge": null,
    "price": 5.99,
    "calories": 15,
    "fat": 0,
    "carbs": 5,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/sugar-free-syrup?pid=c6cba8bc-3e15-48e7-1cfe-08dd81f6ccf0",
    "imageUrl": "/api/products/images/fitpromeals/products/sugar-free-syrup.webp",
    "imageAlt": "SUGAR FREE SYRUP prepared by The Prep Kitchen",
    "affiliateTitle": "SUGAR FREE SYRUP Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review SUGAR FREE SYRUP from The Prep Kitchen with 0g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "SUGAR FREE SYRUP is a prepared sauce from The Prep Kitchen with 15 calories, 0g protein, 5g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "SUGAR FREE SYRUP is a prepared sauce from The Prep Kitchen with 15 calories, 0g protein, 5g carbs, 0g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "c6cba8bc-3e15-48e7-1cfe-08dd81f6ccf0",
    "pradoVariantId": "576fa961-1402-4b78-62ce-08dd81f6ccf8"
  },
  {
    "name": "Whipped Cream Cheese",
    "slug": "whipped-cream-cheese",
    "category": "Sauces",
    "badge": null,
    "price": 4.99,
    "calories": 70,
    "fat": 6,
    "carbs": 3,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/whipped-cream-cheese?pid=498cda6f-3b36-450d-5ae4-08dd81f6e1e9",
    "imageUrl": "/api/products/images/fitpromeals/products/whipped-cream-cheese.webp",
    "imageAlt": "Whipped Cream Cheese prepared by The Prep Kitchen",
    "affiliateTitle": "Whipped Cream Cheese Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Whipped Cream Cheese from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Whipped Cream Cheese is a prepared sauce from The Prep Kitchen with 70 calories, 1g protein, 3g carbs, 6g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Whipped Cream Cheese is a prepared sauce from The Prep Kitchen with 70 calories, 1g protein, 3g carbs, 6g fat per listed serving. Pair it with meals, proteins, or sides to add flavor without additional preparation.",
    "pradoProductId": "498cda6f-3b36-450d-5ae4-08dd81f6e1e9",
    "pradoVariantId": "6d3a8c5d-0864-4f71-85f8-08dd81f6e1f5"
  },
  {
    "name": "Beats - Tribal Cold Press Fresh Juice",
    "slug": "beats-tribal-cold-press-fresh-juice",
    "category": "Drinks",
    "badge": null,
    "price": 7.49,
    "calories": 140,
    "fat": 1,
    "carbs": 33,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/beats-tribal-cold-press-fresh-juice?pid=b49efbe1-5fec-4cc1-6c90-08dd81f70030",
    "imageUrl": "/api/products/images/fitpromeals/products/beats-tribal-cold-press-fresh-juice.webp",
    "imageAlt": "Beats - Tribal Cold Press Fresh Juice prepared by The Prep Kitchen",
    "affiliateTitle": "Beats - Tribal Cold Press Fresh Juice Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Beats - Tribal Cold Press Fresh Juice from The Prep Kitchen with 0g protein. See nutrition details and check current DFW availability through our a…",
    "description": "Beats - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 140 calories, 0g protein, 33g carbs, 1g fat. It is a convenient complement to a prepared meal order. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Beats - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 140 calories, 0g protein, 33g carbs, 1g fat. It is a convenient complement to a prepared meal order.",
    "pradoProductId": "b49efbe1-5fec-4cc1-6c90-08dd81f70030",
    "pradoVariantId": "42ab9065-d268-4c52-a38e-08dd81f7003c"
  },
  {
    "name": "Chief - Tribal Cold Press Fresh Juice",
    "slug": "chief-tribal-cold-press-fresh-juice",
    "category": "Drinks",
    "badge": null,
    "price": 7.49,
    "calories": 40,
    "fat": 0,
    "carbs": 9,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/chief-tribal-cold-press-fresh-juice?pid=9dcff00b-85ac-4806-4b68-08dd81f701b4",
    "imageUrl": "/api/products/images/fitpromeals/products/chief-tribal-cold-press-fresh-juice.webp",
    "imageAlt": "Chief - Tribal Cold Press Fresh Juice prepared by The Prep Kitchen",
    "affiliateTitle": "Chief - Tribal Cold Press Fresh Juice Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Chief - Tribal Cold Press Fresh Juice from The Prep Kitchen with 0g protein. See nutrition details and check current DFW availability through our a…",
    "description": "Chief - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 40 calories, 0g protein, 9g carbs, 0g fat. It is a convenient complement to a prepared meal order. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Chief - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 40 calories, 0g protein, 9g carbs, 0g fat. It is a convenient complement to a prepared meal order.",
    "pradoProductId": "9dcff00b-85ac-4806-4b68-08dd81f701b4",
    "pradoVariantId": "9c1a0269-4b01-4100-b06a-08dd81f701bb"
  },
  {
    "name": "Medicine Man - Tribal Cold Press Fresh Juice",
    "slug": "medicine-man-tribal-cold-press-fresh-juice",
    "category": "Drinks",
    "badge": null,
    "price": 7.49,
    "calories": 140,
    "fat": 1,
    "carbs": 30,
    "protein": 2,
    "sourceUrl": "https://theprepkitchen.com/product/medicine-man-tribal-juice?pid=7570d8ee-46f9-49f7-4484-08dd81f70438",
    "imageUrl": "/api/products/images/fitpromeals/products/medicine-man-tribal-cold-press-fresh-juice.webp",
    "imageAlt": "Medicine Man - Tribal Cold Press Fresh Juice prepared by The Prep Kitchen",
    "affiliateTitle": "Medicine Man - Tribal Cold Press Fresh Juice Meal in DFW | DFW F…",
    "affiliateMeta": "Review Medicine Man - Tribal Cold Press Fresh Juice from The Prep Kitchen with 2g protein. See nutrition details and check current DFW availability throug…",
    "description": "Medicine Man - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 140 calories, 2g protein, 30g carbs, 1g fat. It is a convenient complement to a prepared meal order. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Medicine Man - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 140 calories, 2g protein, 30g carbs, 1g fat. It is a convenient complement to a prepared meal order.",
    "pradoProductId": "7570d8ee-46f9-49f7-4484-08dd81f70438",
    "pradoVariantId": "10ee3975-747d-45b8-71fe-08dd81f70440"
  },
  {
    "name": "Pony Ride - Tribal Cold Press Fresh Juice",
    "slug": "pony-ride-tribal-cold-press-fresh-juice",
    "category": "Drinks",
    "badge": null,
    "price": 7.49,
    "calories": 160,
    "fat": 0,
    "carbs": 38,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/pony-ride-tribal-cold-fresh-juice?pid=92c71389-892a-4a3c-957a-08dd81f70563",
    "imageUrl": "/api/products/images/fitpromeals/products/pony-ride-tribal-cold-press-fresh-juice.webp",
    "imageAlt": "Pony Ride - Tribal Cold Press Fresh Juice prepared by The Prep Kitchen",
    "affiliateTitle": "Pony Ride - Tribal Cold Press Fresh Juice Meal in DFW | DFW Fit…",
    "affiliateMeta": "Review Pony Ride - Tribal Cold Press Fresh Juice from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through o…",
    "description": "Pony Ride - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 160 calories, 1g protein, 38g carbs, 0g fat. It is a convenient complement to a prepared meal order. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Pony Ride - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 160 calories, 1g protein, 38g carbs, 0g fat. It is a convenient complement to a prepared meal order.",
    "pradoProductId": "92c71389-892a-4a3c-957a-08dd81f70563",
    "pradoVariantId": "c920e056-a4de-426e-a8d2-08dd81f7056b"
  },
  {
    "name": "Rain Dance - Tribal Cold Press Fresh Juice",
    "slug": "rain-dance-tribal-cold-press-fresh-juice",
    "category": "Drinks",
    "badge": null,
    "price": 7.49,
    "calories": 70,
    "fat": 1,
    "carbs": 14,
    "protein": 1,
    "sourceUrl": "https://theprepkitchen.com/product/rain-dance-tribal-juice?pid=cab3c73c-b592-47e3-0b3c-08dd81f706a8",
    "imageUrl": "/api/products/images/fitpromeals/products/rain-dance-tribal-cold-press-fresh-juice.webp",
    "imageAlt": "Rain Dance - Tribal Cold Press Fresh Juice prepared by The Prep Kitchen",
    "affiliateTitle": "Rain Dance - Tribal Cold Press Fresh Juice Meal in DFW | DFW Fit…",
    "affiliateMeta": "Review Rain Dance - Tribal Cold Press Fresh Juice from The Prep Kitchen with 1g protein. See nutrition details and check current DFW availability through…",
    "description": "Rain Dance - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 70 calories, 1g protein, 14g carbs, 1g fat. It is a convenient complement to a prepared meal order. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Rain Dance - Tribal Cold Press Fresh Juice is a ready-to-enjoy beverage available through The Prep Kitchen with 70 calories, 1g protein, 14g carbs, 1g fat. It is a convenient complement to a prepared meal order.",
    "pradoProductId": "cab3c73c-b592-47e3-0b3c-08dd81f706a8",
    "pradoVariantId": "823053c7-47ce-4426-a266-08dd81f706af"
  },
  {
    "name": "FRESH JUICE SAMPLER - PACK",
    "slug": "fresh-juice-sampler-pack",
    "category": "Drinks",
    "badge": null,
    "price": 35.99,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/fresh-juice-sampler7-pack?pid=c05118df-fdbd-4879-3d11-08dda87c73ed",
    "imageUrl": "/api/products/images/fitpromeals/products/fresh-juice-sampler-pack.webp",
    "imageAlt": "FRESH JUICE SAMPLER - PACK prepared by The Prep Kitchen",
    "affiliateTitle": "FRESH JUICE SAMPLER - PACK Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review FRESH JUICE SAMPLER - PACK from The Prep Kitchen. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "FRESH JUICE SAMPLER - PACK is a ready-to-enjoy beverage available through The Prep Kitchen. It is a convenient complement to a prepared meal order. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "FRESH JUICE SAMPLER - PACK is a ready-to-enjoy beverage available through The Prep Kitchen. It is a convenient complement to a prepared meal order.",
    "pradoProductId": "c05118df-fdbd-4879-3d11-08dda87c73ed",
    "pradoVariantId": "ab247420-b3db-4d43-477f-08dda87c73f0"
  },
  {
    "name": "Meal Container w/ Lid",
    "slug": "meal-container-w-lid",
    "category": "Other",
    "badge": null,
    "price": 1.0,
    "calories": 0,
    "fat": 0,
    "carbs": 0,
    "protein": 0,
    "sourceUrl": "https://theprepkitchen.com/product/meal-container-w-lid?pid=660b030b-720b-4862-d870-08dd81f5e460",
    "imageUrl": "/api/products/images/fitpromeals/products/meal-container-w-lid.webp",
    "imageAlt": "Meal Container w/ Lid prepared by The Prep Kitchen",
    "affiliateTitle": "Meal Container w/ Lid Meal in DFW | DFW Fit Meals",
    "affiliateMeta": "Review Meal Container w/ Lid from The Prep Kitchen with 0g protein. See nutrition details and check current DFW availability through our affiliate link.",
    "description": "Meal Container w/ Lid is available from The Prep Kitchen with 0 calories, 0g protein, 0g carbs, 0g fat. Review the merchant page for current ingredients, availability, serving details, and ordering options. Check current availability and order directly from The Prep Kitchen through the affiliate link.",
    "shortDescription": "Meal Container w/ Lid is available from The Prep Kitchen with 0 calories, 0g protein, 0g carbs, 0g fat. Review the merchant page for current ingredients, availability, serving details, and ordering options.",
    "pradoProductId": "660b030b-720b-4862-d870-08dd81f5e460",
    "pradoVariantId": "16d4fec7-8c72-42fd-0370-08dd81f5e468"
  }
];

export const CATEGORIES = ["Breakfast", "Build-Your-Meal", "Bulk Protein & Sides", "Desserts & Snacks", "Drinks", "Lunch & Dinner", "Other", "Sauces"];

export function getProductBySlug(slug) {
  return PRODUCTS.find(p => p.slug === slug);
}

export function getProductsByCategory(category) {
  if (!category || category === 'All') return PRODUCTS;
  return PRODUCTS.filter(p => p.category === category);
}

// Category slug mapping for /meals/category/:slug routes
export const CATEGORY_SLUG_MAP = {
  'breakfast': 'Breakfast',
  'build-your-meal': 'Build-Your-Meal',
  'bulk-protein-sides': 'Bulk Protein & Sides',
  'desserts-snacks': 'Desserts & Snacks',
  'drinks': 'Drinks',
  'lunch-dinner': 'Lunch & Dinner',
  'other': 'Other',
  'sauces': 'Sauces',
};

export function categoryToSlug(category) {
  return Object.entries(CATEGORY_SLUG_MAP).find(([, v]) => v === category)?.[0] || category.toLowerCase().replace(/[&\s]+/g, '-').replace(/-+/g, '-');
}

export function getCategoryBySlug(slug) {
  return CATEGORY_SLUG_MAP[slug] || null;
}

export const CATEGORY_SEO = {
  'breakfast': {
    title: 'Breakfast Meal Prep from The Prep Kitchen | DFW Fit Meals',
    description: 'Browse all breakfast meal prep options from The Prep Kitchen — waffles, egg bowls, burritos, pancakes & more. Macro-tracked and delivered in DFW. Use code NINJA for 20% off.',
    h1: 'Breakfast Meals',
    intro: 'Start your mornings right with macro-tracked breakfast meals from The Prep Kitchen. From protein pancakes to egg white bites — fueling DFW one breakfast at a time.',
  },
  'lunch-dinner': {
    title: 'Lunch & Dinner Meal Prep from The Prep Kitchen | DFW Fit Meals',
    description: 'Explore 58+ lunch and dinner meal prep options — chicken, beef, pasta, bowls & more. Macro-tracked, never frozen, delivered Sundays in DFW. Code NINJA saves 20%.',
    h1: 'Lunch & Dinner Meals',
    intro: 'The biggest selection — over 58 lunch and dinner meals, each macro-tracked and chef-prepared by The Prep Kitchen. Perfect for meal preppers across DFW.',
  },
  'bulk-protein-sides': {
    title: 'Bulk Protein & Sides from The Prep Kitchen | DFW Fit Meals',
    description: 'Order bulk protein (chicken, steak, ground turkey) and sides (rice, sweet potato, veggies) from The Prep Kitchen. Build your own meals. NINJA code = 20% off.',
    h1: 'Bulk Protein & Sides',
    intro: 'Build your perfect plate. Bulk proteins and sides let you mix-and-match macros exactly how you want. Ideal for bodybuilders, athletes, and serious meal preppers.',
  },
  'sauces': {
    title: 'Sauces & Dressings from The Prep Kitchen | DFW Fit Meals',
    description: 'Add flavor without the guilt. Browse macro-friendly sauces from The Prep Kitchen — teriyaki, buffalo, ranch & more. Use code NINJA for 20% off.',
    h1: 'Sauces & Dressings',
    intro: 'Elevate any meal with The Prep Kitchen\'s signature sauces. Low-cal, big flavor — the secret weapon of every serious meal prepper.',
  },
  'drinks': {
    title: 'Drinks & Beverages from The Prep Kitchen | DFW Fit Meals',
    description: 'Protein shakes, smoothies, and drinks from The Prep Kitchen. Macro-tracked beverages to complement your meal prep. Use NINJA for 20% off.',
    h1: 'Drinks & Beverages',
    intro: 'Fuel up or cool down. Protein-packed beverages designed to complement your weekly meal prep.',
  },
  'desserts-snacks': {
    title: 'Desserts & Snacks from The Prep Kitchen | DFW Fit Meals',
    description: 'Satisfy your sweet tooth the macro-friendly way. Protein cookies, desserts, and snacks from The Prep Kitchen. NINJA code for 20% off.',
    h1: 'Desserts & Snacks',
    intro: 'Treat yourself without derailing your macros. Protein cookies, sweet bites, and guilt-free snacks from The Prep Kitchen.',
  },
  'build-your-meal': {
    title: 'Build Your Own Meal | The Prep Kitchen | DFW Fit Meals',
    description: 'Customize your meal prep — pick your protein, carb, and veggie. Build-your-meal options from The Prep Kitchen. Use code NINJA for 20% off.',
    h1: 'Build Your Own Meal',
    intro: 'Total control over your plate. Choose your protein, carb source, and veggies — The Prep Kitchen builds it fresh for you.',
  },
  'other': {
    title: 'Other Meal Prep Options from The Prep Kitchen | DFW Fit Meals',
    description: 'Browse additional meal prep options, bundles, and specials from The Prep Kitchen. Use code NINJA for 20% off your first order.',
    h1: 'Other Options',
    intro: 'Bundles, specials, and more from The Prep Kitchen.',
  },
};

export function buildAffiliateUrl(sourceUrl) {
  try {
    const url = new URL(sourceUrl);
    url.searchParams.set('ref', AFFILIATE_CODE);
    url.searchParams.set('utm_source', 'dfwfitmeals');
    url.searchParams.set('utm_medium', 'affiliate');
    url.searchParams.set('utm_campaign', 'meal_catalog');
    return url.toString();
  } catch {
    return sourceUrl;
  }
}

/**
 * Smart Recommendations — suggest complementary products based on the current one.
 * Returns up to 6 items with a "reason" label explaining why they pair well.
 */
export function getSmartRecommendations(currentProduct, count = 6) {
  if (!currentProduct) return [];
  const candidates = [];
  const exclude = new Set([currentProduct.slug]);
  const cat = currentProduct.category;

  const add = (product, reason, score) => {
    if (exclude.has(product.slug)) return;
    exclude.add(product.slug);
    candidates.push({ product, reason, score });
  };

  // Cross-category pairing rules
  const PAIRINGS = {
    'Lunch & Dinner': [
      { category: 'Sauces', reason: 'Pairs well', score: 90 },
      { category: 'Drinks', reason: 'Complete your meal', score: 80 },
      { category: 'Bulk Protein & Sides', reason: 'Add a side', score: 85 },
      { category: 'Desserts & Snacks', reason: 'Finish with a treat', score: 70 },
    ],
    'Breakfast': [
      { category: 'Drinks', reason: 'Morning fuel', score: 90 },
      { category: 'Sauces', reason: 'Add flavor', score: 75 },
      { category: 'Desserts & Snacks', reason: 'Grab a snack', score: 70 },
    ],
    'Bulk Protein & Sides': [
      { category: 'Sauces', reason: 'Add flavor', score: 90 },
      { category: 'Bulk Protein & Sides', reason: 'Build your plate', score: 80 },
      { category: 'Lunch & Dinner', reason: 'Try it as a meal', score: 75 },
    ],
    'Sauces': [
      { category: 'Lunch & Dinner', reason: 'Great with this', score: 90 },
      { category: 'Bulk Protein & Sides', reason: 'Drizzle on protein', score: 85 },
      { category: 'Breakfast', reason: 'Morning add-on', score: 70 },
    ],
    'Drinks': [
      { category: 'Lunch & Dinner', reason: 'Pair with a meal', score: 90 },
      { category: 'Breakfast', reason: 'Breakfast combo', score: 85 },
      { category: 'Desserts & Snacks', reason: 'Snack + sip', score: 70 },
    ],
    'Desserts & Snacks': [
      { category: 'Drinks', reason: 'Wash it down', score: 90 },
      { category: 'Lunch & Dinner', reason: 'Save room after', score: 80 },
    ],
  };

  // 1. Apply cross-category pairings
  const rules = PAIRINGS[cat] || [];
  for (const rule of rules) {
    const pool = PRODUCTS.filter(p => p.category === rule.category);
    // Pick top 2 from each pairing category (sorted by protein to favor popular items)
    const sorted = [...pool].sort((a, b) => (b.protein || 0) - (a.protein || 0));
    sorted.slice(0, 2).forEach(p => add(p, rule.reason, rule.score));
  }

  // 2. Similar macros from same category (close calorie match, different meal)
  const sameCategory = PRODUCTS.filter(p => p.category === cat && p.slug !== currentProduct.slug);
  const byCalorieProximity = [...sameCategory].sort((a, b) => {
    return Math.abs(a.calories - currentProduct.calories) - Math.abs(b.calories - currentProduct.calories);
  });
  byCalorieProximity.slice(0, 2).forEach(p => add(p, 'Similar macros', 60));

  // 3. High-protein picks if current item is low protein
  if (currentProduct.protein < 20) {
    const highProtein = PRODUCTS.filter(p => p.protein >= 30 && p.slug !== currentProduct.slug)
      .sort((a, b) => b.protein - a.protein);
    highProtein.slice(0, 2).forEach(p => add(p, 'Boost your protein', 65));
  }

  // Sort by score descending and return top N
  candidates.sort((a, b) => b.score - a.score);
  return candidates.slice(0, count);
}
